const fr = {
  common: {
    photo: 'Photo',
    continue: 'Continuer',
    dragToReorder: 'Glisser pour réordonner', dragToMove: 'Glisser pour déplacer',
    select: "Sélectionner", noResults: "Aucun résultat",
    save: 'Enregistrer', cancel: 'Annuler', edit: 'Modifier', delete: 'Supprimer', add: 'Ajouter',
    back: 'Retour', close: 'Fermer', copy: 'Copier', copied: 'Copié !',
    loadingApp: 'Chargement de Gromly',
    loading: 'Chargement…', search: 'Rechercher', open: 'Ouvrir', confirm: 'Confirmer',
    enable: 'Activer', disable: 'Désactiver', create: 'Créer', invite: 'Inviter',
    remove: 'Supprimer', generate: 'Générer',
    fromDocument: 'Du document', fromDocumentHint: 'Importé de votre document — votre base fixe. L\'assistant construit autour sans la réorganiser ni la supprimer.',
    deleting: 'Suppression…', required: 'Requis', confirmDelete: 'Êtes-vous sûr ? Cette action est irréversible.',
    clear: 'Effacer', today: "Aujourd'hui",
    pickTime: 'Choisir une heure', pickDate: 'Choisir une date', pickDateTime: 'Choisir date et heure', time: 'Heure', done: 'Terminé',
    areYouSure: 'Sûr ?', yesDelete: 'Oui, supprimer', deleteFailed: 'Impossible de supprimer',
    accept: 'Accepter', discard: 'Ignorer', ai: 'IA', or: 'ou',
    error: "Une erreur s'est produite", saving: 'Enregistrement…',
  },
  upload: {
    fileTooLarge: '« {{name}} » est trop volumineux : la limite est de {{size}}',
    fileUnsupported: '« {{name}} » n’est pas un type de fichier pris en charge',
    imageUnreadable: 'Impossible de lire la photo « {{name}} ». Essaie de l’exporter en JPEG.',
    storageFull: "Tu as atteint la limite de stockage pour les photos",
    storageFullBatch_one: "Tu as atteint la limite de stockage pour les photos : {{count}} photo n’a pas été envoyée",
    storageFullBatch_other: "Tu as atteint la limite de stockage pour les photos : {{count}} photos n’ont pas été envoyées",
    progress: { title: "Envoi de la photo {{current}} sur {{total}}", keepOpen: "Garde cette page ouverte jusqu’à la fin" },
  },
  nav: {
    myTrips: 'Mes voyages', menu: 'Menu', docs: 'Docs', signOut: 'Se déconnecter', security: 'Sécurité', agencyHome: "Accueil", collapseMenu: "Réduire le menu", expandMenu: "Développer le menu", agencyTrips: "Voyages", mode: { label: "Passer à", personal: "Mes voyages", admin: "Administration" }, explore: 'Explorer', accountSettings: 'Paramètres du compte',
    lightMode: 'Passer en mode clair', darkMode: 'Passer en mode sombre', language: 'Langue',
  },
  auth: {
    unverified: {
      title: 'Vérifiez votre email',
      body: "Nous vous avons envoyé un lien à {{email}}. Certaines actions (inviter, publier) sont bloquées jusqu'à ce que vous le confirmiez.",
      resend: 'Renvoyer',
      resent: 'Email renvoyé. Vérifiez votre boîte de réception.',
      alreadyVerified: 'Votre email est déjà vérifié, rechargez la page.',
      resendFailed: 'Impossible de renvoyer. Réessayez dans quelques minutes.',
    },
    login: {
      heroTitle: 'Planifiez chaque\naventure',
      heroSubtitle: "Itinéraires, réservations, dépenses et les petites notes que votre groupe retiendra — gardés dans un endroit tranquille, partagés uniquement avec ceux qui partent.",
      heroFeatures: { flights: 'Vols', hotels: 'Hôtels', places: 'Lieux', expenses: 'Dépenses', checklists: 'Listes', share: 'Partager' },
      heroEyebrow: 'Où commence chaque voyage',
      heroLine1: 'Planifiez', heroLine2: "l'inoubliable,", heroLine3: 'oubliez le', heroLine4: 'reste.',
      title: 'Bon retour', subtitle: 'Connectez-vous à votre compte',
      email: 'Email', password: 'Mot de passe', submit: 'Se connecter',
      noAccount: 'Pas de compte ?', createOne: 'En créer un',
      errorDefault: 'Email ou mot de passe invalide',
      googleAccount: 'Ce compte se connecte avec Google. Choisissez-le dans le sélecteur de compte, ou définissez-lui un mot de passe.',
      appleAccount: 'Ce compte se connecte avec Apple. Utilisez « Continuer avec Apple », ou définissez-lui un mot de passe.',
      setPassword: 'Définir un mot de passe pour ce compte',
      tooManyAttempts: 'Trop de tentatives. Attendez quelques minutes et réessayez.',
      hidePassword: 'Masquer le mot de passe', showPassword: 'Afficher le mot de passe',
      breadcrumb: 'Compte · se connecter',
      newHere: 'Nouveau ici ?',
      createAccount: 'Créer un compte',
      continueJourney: 'Continuez votre voyage.',
      continueSubtitle: 'Connectez-vous pour reprendre là où vous en étiez — vos voyages sont là où vous les avez laissés.',
      forgot: 'Oublié ?',
      passwordPlaceholder: 'Minimum 8 caractères',
      rememberMe: 'Rester connecté sur cet appareil',
      orContinueWith: 'ou continuer avec',
      continueWithGoogle: 'Continuer avec Google',
      continueWithApple: 'Continuer avec Apple',
      footer: { privacy: 'Confidentialité', terms: 'Conditions', status: 'Statut', copyright: '© 2026 Gromly · Vestigi Platform, S.L.' },
    },
    forgotPassword: {
      eyebrow: 'Récupération du compte',
      title: 'Mot de passe oublié ?',
      subtitle: "Saisissez l'email utilisé à l'inscription et nous vous enverrons un lien pour en choisir un nouveau.",
      emailLabel: 'Adresse email',
      submit: 'Envoyer le lien',
      failed: "Impossible d'envoyer l'email. Réessayez dans quelques minutes.",
      sentTitle: 'Consultez votre boîte mail',
      sentBody: 'Si {{email}} correspond à un compte, le lien est déjà en route.',
      sentHint: "Le lien expire dans une heure et ne fonctionne qu'une fois. Vous ne le trouvez pas ? Vérifiez vos spams.",
      backToLogin: 'Retour à la connexion',
    },
    resetPassword: {
      eyebrow: 'Nouveau mot de passe',
      title: 'Choisissez un nouveau mot de passe',
      subtitle: "Un mot de passe dont vous vous souviendrez : il vous servira aussi sur vos autres appareils.",
      checking: 'Vérification de votre lien…',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Répétez le mot de passe',
      confirmPlaceholder: 'Saisissez-le à nouveau',
      tooShort: 'Au moins {{min}} caractères.',
      mismatch: 'Les deux mots de passe ne correspondent pas.',
      submit: 'Changer le mot de passe',
      failed: 'Impossible de changer votre mot de passe. Réessayez.',
      twoFactorNeeded: 'Ce compte utilise la double authentification. Saisissez votre code pour continuer.',
      twoFactorHint: "Celui de votre application d'authentification, le même qu'à la connexion.",
      invalidTitle: 'Ce lien ne fonctionne plus',
      invalidBody: "Les liens expirent au bout d'une heure et ne servent qu'une fois. Demandez-en un nouveau, il arrive en quelques secondes.",
      requestNew: 'Demander un nouveau lien',
      doneTitle: 'Mot de passe modifié',
      doneBody: 'Vous avez été déconnecté partout ailleurs. Connectez-vous avec le nouveau mot de passe pour reprendre où vous en étiez.',
      goToLogin: 'Aller à la connexion',
    },
    twoFactor: {
      title: 'Authentification à deux facteurs',
      subtitle: 'Entrez le code à 6 chiffres de votre application d\'authentification',
      codeLabel: 'Code d\'authentification',
      verify: 'Vérifier',
      back: 'Retour à la connexion',
      invalidCode: 'Code invalide ou expiré',
      modalTitle: 'Authentification à deux facteurs',
      statusEnabled: 'La 2FA est activée. Votre compte est protégé par une application d\'authentification.',
      statusDisabled: 'La 2FA est désactivée. Activez-la pour ajouter une couche de sécurité supplémentaire.',
      enable: 'Activer la 2FA',
      disable: 'Désactiver la 2FA',
      scanQr: 'Scannez ce QR code avec Google Authenticator, Authy ou toute application TOTP.',
      manualEntry: 'Ou entrez ce secret manuellement :',
      confirm: 'Activer la 2FA',
      confirmDisable: 'Désactiver la 2FA',
      disablePrompt: 'Entrez votre code d\'authentification actuel pour désactiver la 2FA.',
      setupError: 'Impossible de démarrer la configuration 2FA. Réessayez.',
    },
    register: {
      nationality: "Nationalité",
      heroTitle: 'Votre prochaine\aventure vous attend',
      heroSubtitle: 'Créez un compte et commencez à planifier\ndes voyages inoubliables avec votre groupe.',
      heroFeatures: ["Planificateur d'itinéraires jour par jour", 'Dépenses partagées et dettes', 'Lieux, réservations et cartes', 'Invitez des compagnons de voyage'],
      heroEyebrow: 'Votre prochaine aventure commence ici',
      heroLine1a: 'Tout grand ', heroLine1b: 'voyage', heroLine2a: 'commence par un ', heroLine2b: 'plan.',
      heroSubheading: 'Construisez des itinéraires, partagez les dépenses et gardez tous les détails du voyage dans un endroit tranquille — partagé uniquement avec les personnes qui partent.',
      title: 'Créer un compte', subtitle: 'Commencez à planifier vos voyages',
      displayName: 'Nom affiché', username: 'Nickname', email: 'Email', password: 'Mot de passe',
      passwordPlaceholder: 'Minimum 8 caractères', submit: 'Créer un compte',
      hasAccount: 'Déjà un compte ?', signIn: 'Se connecter',
      errorDefault: "L'inscription a échoué",
      hidePassword: 'Masquer le mot de passe', showPassword: 'Afficher le mot de passe',
      invitePreview: "Après la création de votre compte nous vous joindrons au voyage \"{{tripName}}\" de {{inviterName}}.",
      mustAcceptTerms: 'Vous devez accepter les conditions et la politique de confidentialité pour continuer.',
      toastJoined: 'Vous avez rejoint le voyage',
      toastInviteExpired: "Compte créé, mais nous n'avons pas pu vous ajouter au voyage (invitation expirée)",
      toastVerifyEmail: 'Nous vous avons envoyé un email pour vérifier votre compte',
      breadcrumb: 'Compte · créer',
      alreadyMember: 'Déjà membre ?',
      signInLink: 'Se connecter',
      tripInviteHeader: 'Invitation de voyage',
      newAccountHeader: 'Nouveau compte',
      startAdventure: 'Commencez votre aventure.',
      createSubtitle: 'Créez votre compte et commencez à planifier votre premier voyage.',
      acceptStart: "J'ai lu et j'accepte les",
      terms: "Conditions d'utilisation",
      and: 'et la',
      privacy: 'Politique de confidentialité',
      or: 'ou',
      orWithEmail: 'ou par email',
    },
    verify: {
      checking: "Vérification de l'email…",
      success: 'Email vérifié',
      failed: "Nous n'avons pas pu vérifier",
      successBody: 'Votre compte est actif. Vous pouvez maintenant inviter des amis à vos voyages et publier du contenu.',
      failedBody: 'Le lien est invalide ou a expiré. Depuis votre profil vous pouvez demander un nouveau lien.',
      goToDashboard: 'Aller au dashboard',
      goHome: "Aller à l'accueil",
    },
    completeProfile: {
      eyebrow: 'Une étape de plus',
      title: 'Complétez votre profil.',
      subtitle: 'Choisissez un pseudo et acceptez nos politiques pour commencer.',
      nicknameLabel: 'Pseudo',
      nicknameHint: 'Minimum 3 caractères. Lettres, chiffres et tiret bas.',
      acceptStart: "J'ai lu et j'accepte les",
      terms: "Conditions d'utilisation",
      and: 'et la',
      privacy: 'Politique de confidentialité',
      continue: 'Continuer',
      mustAccept: 'Vous devez accepter les conditions et la politique de confidentialité pour continuer.',
      saveFailed: "Impossible d'enregistrer le profil",
    },
    callback: {
      signingIn: 'Connexion…',
    },
  },
  invite: {
    errors: {
      invalidTitle: 'Invitation invalide',
      invalidBody: "Le lien ne correspond à aucune invitation active.",
      cancelledTitle: 'Invitation annulée',
      cancelledBody: 'La personne qui vous a invité a annulé cette invitation.',
      expiredTitle: 'Invitation expirée',
      expiredBody: 'Ce lien a expiré. Demandez une nouvelle invitation.',
      usedTitle: 'Invitation déjà utilisée',
      usedBody: 'Ce lien a déjà été utilisé.',
      ownTitle: 'Vous êtes déjà propriétaire du voyage',
      ownBody: "Ce lien est destiné à quelqu'un d'autre. Si vous voulez tester comment accepter une invitation, ouvrez-le dans une fenêtre incognito ou avec un autre compte.",
      emailMismatchTitle: "Cette invitation est pour une autre adresse",
      emailMismatchBody: "Votre agence l'a envoyée à une autre adresse. Connectez-vous avec l'e-mail que vous lui avez donné.",
      failedTitle: "Quelque chose s'est mal passé",
      failedBody: "Nous n'avons pas pu charger l'invitation. Veuillez réessayer.",
    },
    joined: 'Vous avez rejoint le voyage',
    goDashboard: 'Retour au dashboard',
    goHome: "Aller à l'accueil",
    eyebrow: 'Invitation de voyage',
    inviterText: '{{inviterName}} vous invite',
    toCollaborate: 'À collaborer au voyage "{{tripName}}".',
    roleEditor: 'Éditeur',
    roleViewer: 'Lecture seule',
    joining: 'Rejoindre le voyage…',
    needAccount: "Pour accepter vous avez besoin d'un compte Gromly. Si c'est votre première fois, créez-le en 30 secondes. Si vous avez déjà un compte, connectez-vous.",
    createAndJoin: 'Créer un compte et rejoindre',
    haveAccount: "J'ai déjà un compte · se connecter",
    expiresOn: 'Expire le {{date}}',
  },
  dashboard: {
    deleteTripAria: 'Supprimer le voyage',
    greeting: { morning: 'Bonjour', afternoon: 'Bon après-midi', evening: 'Bonsoir' },
    title: 'Vos aventures', tagline: 'Planifiez ensemble. Voyagez mieux.', searchPlaceholder: 'Rechercher des voyages…',
    newTrip: 'Nouveau voyage', newTripShort: 'Nouveau', addTripHint: 'Ajoutez destination, dates et voyageurs',
    stats: { totalTrips: 'Total voyages', destinations: 'Destinations', upcoming: 'À venir', nights: 'Nuits', avgBudget: 'Budget moyen', subPast: '{{count}} passés', subUnique: 'uniques', subTotal: 'total', subPerTrip: 'par voyage', subCredits: 'crédits' },
    filter: { all: 'Tous', upcoming: 'À venir', past: 'Passés' },
    sections: { following: 'Voyages que vous suivez', upcoming: 'À venir', past: 'Passés', horizon: "À l'horizon", brewing: 'Voyages en préparation', alsoPlanning: 'Aussi en cours', pastKicker: 'Là où vous étiez', pastTitle: 'Mémoire', memoryLane: 'Memory lane · déjà vécus', seeAll: 'Voir les {{count}}' },
    eyebrow: { trips_one: '{{count}} voyage', trips_other: '{{count}} voyages', lived_one: '{{count}} vécu', lived_other: '{{count}} vécus' },
    summary: { label: 'Résumé', trips_one: '{{count}} voyage', trips_other: '{{count}} voyages', dests_one: '{{count}} destination', dests_other: '{{count}} destinations', nights_one: '{{count}} nuit', nights_other: '{{count}} nuits', avg: '{{amount}} moyenne', credits: '{{credits}} crédits' },
    toast: {
      loadFailed: 'Impossible de charger les voyages',
      deleted: 'Voyage supprimé',
      published: 'Voyage publié dans la communauté !',
      unpublished: 'Voyage dépublié',
    },
    welcome: {
      title: 'Bienvenue sur Gromly !',
      body: "Nous avons créé un voyage d'exemple à Barcelone pour que vous puissiez explorer toutes les fonctionnalités. Supprimez-le quand vous voulez.",
      explore: 'Explorer le démo →',
      create: 'Créer mon premier voyage',
    },
    community: {
      removeTitle: 'Retirer de la communauté',
      shareTitle: 'Partager le voyage avec la communauté',
      removeBody: '{{name}} ne sera plus visible par les autres voyageurs.',
      shareBody: '{{name}} sera publié dans le fil de la communauté et visible pour tous sur Gromly.',
      remove: 'Retirer',
      publish: 'Publier le voyage',
      shared: 'Partagé',
      share: 'Partager',
      community: 'Communauté',
    },
    hero: {
      onRoadNow: 'En voyage maintenant',
      nextAdventure: 'Votre prochaine aventure',
      departingIn: 'Commence dans',
      day: 'jour',
      days: 'jours',
      daysLeft: 'Jours restants',
      left: 'restants',
      onRoad: 'En voyage',
      planning: 'En préparation',
      night: 'nuit',
      nights: 'nuits',
      openItinerary: "Ouvrir l'itinéraire",
      fieldDestination: 'Destination',
      fieldDates: 'Dates',
      fieldTravelers: 'Voyageurs',
      people_one: '{{count}} personne',
      people_other: '{{count}} personnes',
    },
    card: {
      active: 'En cours',
      tomorrow: 'Demain',
      inDays_one: 'dans {{count}} jour',
      inDays_other: 'dans {{count}} jours',
    },
    today: "Aujourd'hui !", tomorrow: 'Demain', daysUntil: '{{count}}j', pastLabel: 'Passé',
    delete: 'Supprimer', open: 'Ouvrir',
    deleteTrip: { title: 'Supprimer ce voyage ?', body: '« {{name}} » ainsi que tout son itinéraire, ses lieux, dépenses et réservations seront définitivement supprimés.' },
    empty: {
      kicker: 'Commencez ici',
      title: 'Planifiez votre premier voyage',
      subtitle: "Créez un voyage, invitez votre compagnon d'aventure et commencez à organiser l'itinéraire, les lieux, les dépenses et les checklists — tout en un endroit.",
      cta: 'Nouveau voyage',
      exploreCta: 'Explorer les voyages',
      featuresLabel: 'Fonctionnalités',
      features: [
        { label: 'Itinéraire jour par jour', desc: 'Activités, horaires et ordre' },
        { label: 'Lieux et carte', desc: 'Enregistrez des lieux, voyez l’itinéraire' },
        { label: 'Planification par IA', desc: 'L’IA prépare votre voyage' },
        { label: 'Vols et hôtels', desc: 'Réservations et billets réunis' },
        { label: 'Dépenses partagées', desc: 'Règlement automatique des dettes' },
        { label: 'Planifiez en équipe', desc: 'Invitez et planifiez ensemble' },
        { label: 'Listes et bagages', desc: 'Documents et checklists de valise' },
        { label: 'Galerie photo', desc: 'Vos souvenirs, jour après jour' },
      ],
    },
    modalTitle: 'Planifier un nouveau voyage',
    newTripWizard: {
      progress: "Étape {{current}} sur {{total}}",
      back: "Retour",
      stepLabel: {
        destination: "Destination",
        dates: "Dates",
        legs: "Nuits",
        travellers: "Voyageurs",
        bookings: "Réservations",
        start: "Pour commencer",
        documents: "Documents",
        style: "Votre style",
        summary: "Récapitulatif",
      },
      ask: {
        destination: "Où partez-vous ?",
        dates: "Quand ?",
        legs: "Combien de nuits à chaque endroit ?",
        travellers: "Qui vient ?",
        bookings: "Vous avez déjà des réservations ?",
        start: "Comment voulez-vous commencer ?",
        documents: "Ajoutez ce que vous avez déjà",
        style: "Comment aimez-vous voyager à {{destination}} ?",
        summary: "Votre voyage est prêt à partir",
      },
      hint: {
        destination: "Une ville, une région ou un pays entier. Plusieurs étapes ? Ajoutez-les une par une.",
        legs: "Elles doivent faire le total des nuits du voyage.",
        travellers: "Ajoutez tous ceux qui voyagent : dès le premier jour, vous pourrez partager dépenses, vols et valise.",
        bookings: "Vols, hébergement, transport ou billets, triés par type. Nous les lisons et les ajoutons à Docs avec le fichier joint. Chaque type utilise un crédit IA.",
        start: "Vous pourrez tout modifier ensuite.",
        documents: "Réservations, billets ou un itinéraire en PDF, Word ou Excel. Rien n'est ajouté avant votre confirmation.",
        style: "Pour que les suggestions vous ressemblent.",
        summary: "Vérifiez et donnez-lui un nom.",
      },
      travellersCount_one: "Juste moi",
      travellersCount_other: "Nous sommes {{count}}",
      travellersFewer: "Un de moins",
      travellersMore: "Un de plus",
      travellerDefaultName: "Voyageur {{number}}",
      ticketsCount_one: "{{count}} réservation",
      ticketsCount_other: "{{count}} réservations",
      ticketsNone: "Aucune",
      ticketsSkip: "Passer",
      ticketsMax: "Jusqu'à {{count}} fichiers par type.",
      ticketsAddTo: "Ajouter des fichiers à {{kind}}",
      travellerName: "Nom",
      travellerRemove: "Retirer le voyageur",
      you: "vous",
      birthDateLabel: "Date de naissance (facultatif)",
      birthDateHint: "Facultatif. Avec la date de naissance, nous pourrons vous signaler les tarifs et avantages selon l'âge et mieux adapter le programme.",
      emailLabel: "E-mail",
      emailPlaceholder: "nom@email.com",
      emailHint: "Nous lui enverrons une invitation à rejoindre le voyage.",
      addEmail: "Inviter par e-mail",
      start: {
        recommended: "Recommandé",
        ai: {
          title: "Planifiez-le avec l'IA",
          description: "Nous proposons des lieux, un itinéraire jour par jour et des conseils pratiques.",
        },
        documents: {
          title: "J'ai des documents",
          description: "Ajoutez vos réservations ou un itinéraire et nous construisons le voyage à partir de là.",
        },
        empty: {
          title: "Partir de zéro",
          description: "Créez le voyage vide et remplissez-le à votre rythme.",
        },
      },
      documentsFound: "Voici ce que nous avons trouvé",
      complementAi: "Compléter le reste avec l'IA",
      complementAiHint: "Nous ajoutons des lieux et un itinéraire autour de ce que couvrent déjà vos documents.",
      paceLabel: "Rythme",
      budgetLabel: "Budget",
      interestsLabel: "Qu’est-ce qui vous tente ?",
      notesLabel: "Autre chose ? (facultatif)",
      generatingTitle: "Préparation de votre voyage",
      invitesFailed_one: "Une invitation n'a pas pu être envoyée : vous pouvez l'envoyer depuis Participants.",
      invitesFailed_other: "{{count}} invitations n'ont pas pu être envoyées : vous pouvez les envoyer depuis Participants.",
      groupForPrompt_one: "une personne qui voyage seule",
      groupForPrompt_other: "un groupe de {{count}} (leurs âges figurent dans la liste des voyageurs)",
      destinationPlaceholder: 'Ex : Lisbonne, Portugal',
      destinationAddAnother: "Ajouter une autre destination",
      destinationRemove: "Retirer {{name}}",
      legNights_one: "{{count}} nuit",
      legNights_other: "{{count}} nuits",
      legNightsFewer: "Une nuit de moins à {{name}}",
      legNightsMore: "Une nuit de plus à {{name}}",
      legsTotal_one: "{{assigned}} sur {{count}} nuit",
      legsTotal_other: "{{assigned}} sur {{count}} nuits",
      legDays: "Jours {{from}}–{{to}}",
      legDay: "Jour {{day}}",
      legDaysShort: "jours {{from}}–{{to}}",
      legForPrompt_one: "{{name}} ({{count}} nuit)",
      legForPrompt_other: "{{name}} ({{count}} nuits)",
      datesPlaceholder: "Ex : du 3 au 10 août, ou « la première semaine de septembre »",
      datesParseFailed: "Je n'ai pas bien compris ces dates — pouvez-vous les reformuler ?",
      datesPickHint: 'ou choisissez-les dans le calendrier ci-dessous',
      datesAnswer_one: '{{start}} – {{end}} · {{count}} nuit',
      datesAnswer_other: '{{start}} – {{end}} · {{count}} nuits',
      preferencesPlaceholder: 'Ex : rythme tranquille, on adore la gastronomie locale...',
      interestsLoading: 'Recherche de ce que les gens font habituellement ici…',
      interestsFailed: "Impossible de charger des suggestions pour cette destination — vous pouvez tout de même continuer.",
      pace: { relaxed: 'Tranquille', balanced: 'Équilibré', packed: 'Intense' },
      budget: { budget: 'Économique', mid: 'Milieu de gamme', splurge: 'Sans limites' },
      nameLabel: 'Nom du voyage',
      currencyLabel: 'Devise de base',
      currencyHint: 'Les soldes et le budget sont affichés dans cette devise ; les dépenses dans d’autres devises y sont converties.',
      defaultName: 'Voyage à {{destination}}',
      next: 'Continuer',
      editAnswer: 'Modifier la réponse',
      importFromDocument: 'Importer depuis des documents',
      documentsRemove: "Retirer les documents",
      importing: 'Lecture de votre document…',
      importFailed: "Nous n'avons pas pu lire ce document — essayez un autre fichier ou continuez manuellement.",
      importInsufficientCredits: "Vous n'avez plus de crédits IA — vous pouvez tout de même créer le voyage manuellement.",
      create: 'Créer le voyage', created: 'Voyage créé !', failed: 'Impossible de créer le voyage',
      noSpecificInterests: "aucun centre d'intérêt précis indiqué",
      placesSeedPrompt: "Nous planifions un voyage de {{nights}} nuits à {{destination}} à un rythme {{pace}}, pour {{travelers}}, budget {{budget}}. Nous sommes particulièrement intéressés par : {{interests}}. {{notes}} Proposez environ {{targetCount}} lieux formidables qui correspondent à cela — un mélange des centres d'intérêt ci-dessus et quelques bonnes adresses de restaurants ou cafés à proximité.",
      itinerarySeedPrompt: "Organisez tous les lieux que vous venez d'enregistrer en un itinéraire complet jour par jour pour tout le voyage, en gardant un rythme {{pace}}.",
      tipsSeedPrompt: "Donne-moi les conseils les plus essentiels et pratiques pour voyager à {{destination}} — conditions d'entrée (visa, ETA, ESTA…), vaccins recommandés ou précautions sanitaires, assurance voyage, et tout autre conseil local vraiment utile.",
      generating: {
        stepPlaces: 'Lieux à {{destination}}',
        stepPlacesFound_one: '{{count}} trouvé',
        stepPlacesFound_other: '{{count}} trouvés',
        stepItinerary_one: 'Votre itinéraire de {{count}} nuit',
        stepItinerary_other: 'Votre itinéraire de {{count}} nuits',
        stepItineraryDone_one: '{{count}} jour',
        stepItineraryDone_other: '{{count}} jours',
        stepTips: 'Conseils pratiques pour {{destination}}',
        stepTipsDone_one: '{{count}} conseil',
        stepTipsDone_other: '{{count}} conseils',
        stepTickets: "Vos réservations",
        stepTicketsDone_one: "{{count}} ajoutée",
        stepTicketsDone_other: "{{count}} ajoutées",
        ticketsUnplaced_one: "Nous n'avons pas pu lire {{count}} document : il est enregistré dans Notes pour l'ajouter depuis Docs.",
        ticketsUnplaced_other: "Nous n'avons pas pu lire {{count}} documents : ils sont enregistrés dans Notes pour les ajouter depuis Docs.",
        dayStops_one: 'Jour {{number}} · {{count}} étape',
        dayStops_other: 'Jour {{number}} · {{count}} étapes',
        doneEmpty: 'Voyage créé — vous pouvez ajouter des lieux à tout moment depuis l\'onglet Lieux.',
        errorCredits: "Plus de crédits IA — votre voyage a été créé, mais nous n'avons pas pu générer de suggestions cette fois.",
        errorUnknown: "Une erreur est survenue lors de la génération des suggestions — votre voyage a tout de même été créé.",
        cta: 'Voir mon voyage',
      },
    },
  },
  birthDate: {
    day: "Jour",
    month: "Mois",
    year: "Année",
  },
  import: {
    sidebarButton: 'Importer un document',
    title: 'Importer depuis des documents',
    description: "Importez un fichier Word, PDF, Excel ou texte contenant votre plan et nous en extrairons les lieux et l'itinéraire jour par jour. Rien n'est ajouté avant votre confirmation.",
    dropHint: 'Cliquez pour choisir des fichiers',
    addMore: 'Ajouter d\'autres fichiers',
    analyze_one: 'Analyser {{count}} document',
    analyze_other: 'Analyser {{count}} documents',
    formats: 'PDF, Word, Excel, CSV ou images · jusqu\'à 10 fichiers',
    extracting: 'Lecture de vos documents…',
    docProgress: "Document {{current}} sur {{total}}",
    reviewHint: "Choisissez ce que vous ajoutez à votre voyage. Les éléments existants ne sont jamais modifiés.",
    savedDocsNote: 'Documents importés',
    language: {
      title: 'Ce document est en {{document}}',
      hint: 'Votre voyage est en {{trip}}. Traduisez ce que vous importez pour que tout le voyage parle une seule langue. Les noms des lieux ne changent pas.',
      action: 'Traduire en {{trip}}',
      done: 'Contenu traduit dans la langue du voyage',
      failed: 'Traduction impossible. Vous pouvez l\'ajouter tel quel.',
    },
    placesSection_one: '{{count}} lieu',
    placesSection_other: '{{count}} lieux',
    daySection: 'Jour {{number}}',
    daySectionNoNumber: 'Itinéraire',
    activitiesSection_one: "{{count}} activité",
    activitiesSection_other: "{{count}} activités",
    packingCount_one: "{{count}} objet de bagage",
    packingCount_other: "{{count}} objets de bagage",
    flightsSection_one: '{{count}} vol',
    flightsSection_other: '{{count}} vols',
    hotelsSection_one: '{{count}} hébergement',
    hotelsSection_other: '{{count}} hébergements',
    nightsCount_one: '{{count}} nuit',
    nightsCount_other: '{{count}} nuits',
    bookingsSection_one: '{{count}} réservation',
    bookingsSection_other: '{{count}} réservations',
    tipsSection_one: '{{count}} conseil',
    tipsSection_other: '{{count}} conseils',
    packingSection: 'Bagage · {{section}}',
    expensesSection_one: '{{count}} dépense',
    expensesSection_other: '{{count}} dépenses',
    addSelected_one: 'Ajouter {{count}} élément',
    addSelected_other: 'Ajouter {{count}} éléments',
    added_one: '{{count}} élément ajouté',
    added_other: '{{count}} éléments ajoutés',
    mapsQuotaWarning: "Certains lieux n'ont pas pu être localisés sur la carte cette fois-ci, mais ils ont tout de même été importés.",
    errors: {
      nothingFound: "Nous n'avons trouvé aucun lieu ni itinéraire dans ce document.",
      extractFailed: "Nous n'avons pas pu lire ce document — essayez un autre fichier.",
      insufficientCredits: "Vous n'avez plus de crédits IA.",
      rateLimited: "Nous recevons beaucoup de requêtes en ce moment — attendez quelques secondes et réessayez.",
      saveFailed: "Une erreur est survenue lors de l'ajout des éléments — réessayez.",
    },
  },
  trip: {
    editName: 'Cliquez pour renommer le voyage',
    renameFailed: 'Impossible de renommer le voyage',
    destinations: {
      title: "Destinations", edit: "Modifier les destinations",
      hint: "Les endroits que visite le voyage, dans l’ordre, et le nombre de nuits dans chacun.",
      saved: "Destinations mises à jour", failed: "Impossible de modifier les destinations",
      moveUp: "Monter {{name}}", moveDown: "Descendre {{name}}",
    },
    dates: {
      title: 'Dates du voyage', edit: 'Changer les dates', confirm: 'Appliquer',
      saved: 'Dates mises à jour', failed: 'Impossible de changer les dates',
      willMove_one: 'Le voyage raccourcit. 1 étape du jour {{from}} passe au jour {{to}}.',
      willMove_other: 'Le voyage raccourcit. {{count}} étapes du jour {{from}} passent au jour {{to}}.',
      willLoseMeals_one: '1 repas prévu les jours supprimés sera perdu — les repas partent avec leur jour.',
      willLoseMeals_other: '{{count}} repas prévus les jours supprimés seront perdus — les repas partent avec leur jour.',
      willLoseOutfits_one: "Les vêtements prévus pour 1 jour supprimé seront perdus — ils restent dans la valise.",
      willLoseOutfits_other: "Les vêtements prévus pour {{count}} jours supprimés seront perdus — ils restent dans la valise.",
      willAdd_one: 'Un jour vide est ajouté à la fin.', willAdd_other: '{{count}} jours vides sont ajoutés à la fin.',
      noLoss_one: 'Le voyage garde son jour, à la nouvelle date.', noLoss_other: 'Les {{count}} jours gardent leurs étapes, aux nouvelles dates.',
      bookingsOutside_one: '1 réservation tombe hors des nouvelles dates', bookingsOutside_other: '{{count}} réservations tombent hors des nouvelles dates',
      bookingsKept: "Elles gardent leur date : une référence de réservation est un fait, rien n'est déplacé à votre place.",
      aFlight: 'Vol',
    },
    nav: {
      itinerary: 'Itinéraire', places: 'Lieux', map: 'Carte',
      bookings: 'Réservations', expenses: 'Dépenses', meals: 'Repas', packing: 'Bagages', info: 'Conseils',
      plan: 'Plan', placesShort: 'Lieux', mapShort: 'Carte',
      docsShort: 'Docs', money: 'Argent', mealsShort: 'Repas', packingShort: 'Bagages', infoShort: 'Conseils',
      notes: 'Notes', notesShort: 'Notes',
      services: 'Services', servicesShort: 'Services',
      gallery: 'Journal', galleryShort: 'Journal', album: 'Album',
      more: 'Plus',
    },
    sidebar: {
      allTrips: 'Tous les voyages', sections: 'Sections', documentation: 'Documentation', collapse: 'Réduire', expand: 'Développer',
      nights_one: '{{count}} nuit', nights_other: '{{count}} nuits',
      flights_one: '{{count}} vol', flights_other: '{{count}} vols',
      people: '{{count}} personnes',
      manage: 'Gérer',
      workspace: 'Espace de travail',
      travellers_one: 'voyageur',
      travellers_other: 'voyageurs',
      underway: 'En cours',
      tomorrow: 'Demain',
      inDays: 'Dans {{count}} jours',
      ready: '{{pct}}% prêt',
      exportPdf: 'Exporter PDF',
      generating: 'Génération…',
      exportFailed: 'Impossible de générer le PDF',
    },
    cover: {"title": "Photo de couverture", "hint": "Affichée sur la carte et l'en-tête du voyage. Cadrage 3:2.", "add": "Importer une photo", "remove": "Revenir à la couverture automatique", "cropTitle": "Cadrez la couverture", "save": "Enregistrer la couverture", "saved": "Couverture mise à jour", "removed": "Retour à la couverture automatique", "failed": "Impossible de mettre à jour la couverture", "unsupported": "Ce fichier n'est pas une photo utilisable", "alt": "Couverture du voyage", "changeAction": "Changer la couverture"},
    contentLanguage: {
      title: 'Langue du voyage',
      hint: "La langue dans laquelle l'assistante rédige le contenu du voyage : lieux, itinéraire, conseils et bagages. N'affecte que le nouveau contenu ; ce qui est déjà enregistré reste tel quel.",
      saved: 'Langue du voyage mise à jour',
      failed: "Impossible de mettre à jour la langue du voyage",
    },
    manage: { title: 'Gérer le voyage' },
    participants: {
      roles: { OWNER: 'Propriétaire', EDITOR: 'Éditeur', VIEWER: 'Lecteur' },
      title: 'Participants au voyage',
      you: '(vous)',
      pending: 'Invitations en attente',
      invite: "Inviter quelqu'un par email",
      sendInvitation: 'Inviter',
      hint: 'Il recevra un e-mail avec un lien pour rejoindre le voyage. Les deux rôles comptent comme voyageurs : ils partagent les dépenses et ont leur propre valise.',
      viewerHint: 'Seul le propriétaire du voyage peut inviter ou supprimer des voyageurs.',
      roleEditor: 'Éditeur · voyage et modifie',
      roleViewer: 'Lecture seule · voyage, ne modifie pas',
      remove: 'Retirer',
      cancelInvite: 'Annuler',
      roleLabel: 'Rôle : {{role}} · Expire',
      age_one: "{{count}} an",
      age_other: "{{count}} ans",
      placeholder: {
        addBirthDate: "Ajouter la date de naissance",
        editBirthDate: "Modifier la date de naissance",
        noAccount: 'Sans compte',
        addTitle: "Ajouter quelqu'un sans compte",
        addHint: "Pour ceux qui ne sont pas encore inscrits : vous pouvez mettre des dépenses, des vols et des affaires de valise à leur nom, et les lier à leur compte plus tard.",
        namePlaceholder: 'Nom',
        add: 'Ajouter',
        link: 'Lier à un compte',
        inviteHint: "Envoyez-lui une invitation. Quand il l'accepte, tout ce qui est à son nom passe sur son compte.",
        mergeHint: 'Déjà dans le voyage avec son propre compte ?',
        mergeSelect: 'Choisissez qui c’est',
        merge: 'Fusionner',
        confirmMergeTitle: 'Fusionner {{name}} avec {{target}} ?',
        confirmMergeBody: 'Tout ce qui est attribué à {{name}} — dépenses, dettes, vols et affaires de valise — passe à {{target}}. Impossible à annuler.',
        invitationFor: 'pour {{name}}',
        toast: {
          birthDateFailed: "Impossible d'enregistrer la date de naissance",
          added: '{{name}} ajouté au voyage',
          addFailed: "Impossible de l'ajouter",
          merged: 'Fusionné',
          mergeFailed: 'Impossible de fusionner',
        },
      },
      toast: {
        invited: 'Invitation envoyée',
        emailNotVerified: "Vérifiez votre email avant d'inviter d'autres utilisateurs",
        inviteFailed: "Impossible d'envoyer l'invitation",
        revoked: 'Invitation annulée',
        revokeFailed: "Impossible d'annuler",
        removed: 'Participant supprimé',
        roleChanged: 'Rôle mis à jour',
        roleChangeFailed: "Impossible de mettre à jour le rôle",
      },
    },
    notifications: {
      reminder_one: '{{count}} rappel à venir', reminder_other: '{{count}} rappels à venir',
      title: 'Rappels',
    },
    notFound: 'Voyage introuvable',
    demo: {
      banner: 'Ceci est un voyage exemple — explorez librement tout.',
      deleteConfirm: 'Supprimer ce voyage exemple ?',
      deleteFailed: 'Impossible de supprimer le voyage exemple',
    },
    tour: {
      start: 'Voir le tour',
      skip: 'Passer',
      back: 'Retour',
      next: 'Suivant',
      finish: 'Compris',
      steps: {
        importDoc: {
          title: "Vous avez déjà votre voyage dans un document ?",
          body: "Importez un Word, PDF ou Excel — même des billets d'avion ou d'hôtel — et nous en extrayons les lieux, l'itinéraire, les réservations et les dépenses.",
        },
        welcome: {
          title: 'Bienvenue sur Gromly 👋',
          body: 'Ceci est un voyage exemple à Barcelone. Faites un tour rapide pour découvrir tout ce que vous pouvez faire — vous pouvez le passer à tout moment.',
        },
        itinerary: {
          title: 'Planifiez votre itinéraire',
          body: 'Organisez votre voyage jour par jour : ajoutez des activités, fixez des horaires et glissez pour réordonner.',
        },
        itineraryAi: {
          title: 'Voici gIA, partout avec vous',
          body: 'gIA vous accompagne désormais sur chaque écran, ancrée ici à droite. Elle s’adapte à l’endroit où vous êtes — itinéraire, lieux, réservations, valise ou conseils — : dépliez-la pour demander des idées, une journée entière ou de tout réorganiser. Votre conversation vous suit d’un onglet à l’autre.',
        },
        places: {
          title: 'Enregistrez des lieux à visiter',
          body: 'Rassemblez restaurants, monuments et quartiers par catégorie — et l’IA peut vous suggérer de nouveaux lieux adaptés à votre voyage.',
        },
        map: {
          title: 'Tout voir sur la carte',
          body: 'Vos lieux enregistrés et les activités de chaque jour, le tout sur une même carte.',
        },
        mapRoutes: {
          title: 'Les itinéraires sur la carte',
          body: 'Passez en « Itinéraires » pour voir tous les jours sélectionnés d’un coup : temps de trajet, transport par étape et « Optimiser avec gIA » pour réordonner les arrêts d’une journée.',
        },
        bookings: {
          title: 'Gardez vos réservations',
          body: 'Réunissez vols, hôtels et billets au même endroit. Collez une confirmation et l’IA en extrait les détails pour vous.',
        },
        expenses: {
          title: 'Suivez et partagez les dépenses',
          body: 'Notez vos dépenses, fixez un budget et partagez les frais avec vos compagnons de voyage.',
        },
        balances: {
          title: 'Qui doit quoi',
          body: 'Gromly compense toutes les dépenses partagées et vous dit exactement qui doit quoi — sans calcul.',
        },
        packing: {
          title: 'Bagages',
          body: 'Listes de bagages et documents pour ne rien oublier — l’IA peut même créer la liste selon votre destination et vos dates.',
        },
        tips: {
          title: 'Conseils',
          body: 'Des conseils locaux sur les transports, la nourriture et la sécurité — l’IA peut en générer sur mesure pour votre destination.',
        },
        notes: {
          title: 'Notes',
          body: 'Un bloc-notes partagé pour les idées, les liens et tout ce que vous voulez retenir.',
        },
        gallery: {
          title: 'Galerie',
          body: 'Importez vos photos de voyage et parcourez-les organisées par jour.',
        },
        finish: {
          title: 'Tout est prêt !',
          body: 'Voilà pour le tour. Explorez librement — ce voyage exemple est à vous pour vous entraîner, et vous pouvez le supprimer quand vous serez prêt à planifier pour de vrai.',
        },
      },
    },
    share: {
      disable: 'Désactiver le partage', enable: 'Activer le partage', creating: 'Création…',
      disabledToast: 'Partage désactivé', enabledToast: 'Lien de partage créé !',
      panelTitle: 'Montrer le voyage à quelqu’un qui n’y participe pas',
      panelHint: 'Un lien qui ouvre le voyage sans compte. Celui qui l’ouvre n’est pas un voyageur : il n’entre pas dans le partage par personne, n’a pas de valise et ne compte pas dans le nombre de voyageurs. Choisissez ce qui s’affiche.',
      sectionsTitle: 'Ce que montre le lien',
      sectionsHint: 'Ce lien a été créé avant ces options, il montre donc toujours la même chose. Cochez ce que vous voulez ajouter.',
      photosWarning: 'Les liens des photos restent valables une fois copiés, même si vous désactivez cette option.',
      diaryHint: 'Chaque auteur décide quelles entrées sont publiées. Les abonnés s’inscrivent par e-mail depuis le lien. Désactiver le lien les supprime tous.',
      section: {
        ITINERARY: 'Itinéraire',
        NOTES: 'Notes des étapes et des lieux',
        PLACES: 'Lieux enregistrés',
        MAP: 'Carte',
        MEALS: 'Repas',
        TIPS: 'Conseils',
        PHOTOS: 'Photos',
        DIARY: 'Journal',
        BOOKINGS: 'Vols, hébergements et réservations',
      },
    },
    story: {
      entry: 'Story Instagram',
      title: 'Story Instagram',
      upload: 'Importer une photo',
      background: 'Fond',
      gradient: { paper: 'Crème', ink: 'Noir' },
      framingHint: "Faites glisser pour déplacer la photo, utilisez la molette pour zoomer",
      statDays: 'Jours', statStops: 'Étapes', statDistance: 'Distance',
      download: 'Télécharger', share: 'Partager',
      hint: 'Enregistrez l\'image et ajoutez-la à votre story — 1080 × 1920.',
      previewAlt: 'Aperçu de la story',
      imageFailed: 'Impossible de charger cette image', exportFailed: 'Impossible de créer l\'image',
    },
  },
  linkedDelete: { both: "Supprimer les deux" },
  itinerary: {
    stopPhotos_one: '{{count}} photo de cette étape', stopPhotos_other: '{{count}} photos de cette étape',
    // ADR-0039: a stop of the travellers' own, as agency staff see it.
    maskedStop: {
      title: "Programme des voyageurs",
      hint: "C'est le leur : l'agence ne voit pas de quoi il s'agit.",
    },
    deleteLinked: {
      title_one: "Cette étape est un repas prévu",
      title_other: "{{count}} de ces étapes sont des repas prévus",
      body_one: "Supprimer aussi le repas dans Repas ?",
      body_other: "Supprimer aussi ces repas dans Repas ?",
      only_one: "Seulement l'étape",
      only_other: "Seulement les étapes",
    },
    suggestTime: {
      use: 'utiliser',
      hint: 'Calculée à partir de l’étape précédente et du trajet entre les deux. Cliquez pour l’utiliser.',
      noTravel: 'Calculée à partir de l’étape précédente. Le trajet n’est pas encore compté.',
    },
    schedule: {
      from: 'à partir de',
      dayStart: 'La journée commence à',
      setDayStart: 'Définir une heure de début',
      clear: 'Revenir aux heures manuelles',
      hint: 'Les heures découlent de celle-ci, de la durée de chaque étape et des trajets.',
      manual: 'Les heures de cette journée sont celles que vous avez saisies.',
      estimated: 'estimée',
      noTravel: 'Trajets pas encore comptés — calculez-les et la journée se recalera.',
      overrun: 'Ne tient pas avant cette heure fixe',
      locked: 'Heure fixe',
      timeMode: 'Type d’heure',
      modeAuto: 'Calculée',
      modeFixed: 'Fixe',
      autoHint: 'S’ajuste seule selon l’ordre, les durées et les trajets.',
      fixedHint: 'Ne bouge pas même si vous réorganisez la journée.',
    },
    title: 'Itinéraire',
    subtitle_one: '{{count}} jour · {{nights}} nuits',
    subtitle_other: '{{count}} jours · {{nights}} nuits',
    views: { list: 'Liste', timeline: 'Chronologie' },
    addDay: 'Ajouter un jour',
    heading: 'Le plan',
    daysPlanned_one: '{{count}} jour planifié',
    daysPlanned_other: '{{count}} jours planifiés',
    legend: { hasActivities: 'A des activités', today: "Aujourd'hui" },
    dayLabel: 'Jour {{n}}',
    dayShort: 'J{{n}}',
    weather: {
      condition: { clear: 'Dégagé', fair: 'Peu nuageux', partlyCloudy: 'Partiellement nuageux', cloudy: 'Nuageux', fog: 'Brouillard', drizzle: 'Pluie faible', rain: 'Pluie', snow: 'Neige', thunder: 'Orages' },
      typicalFor: 'typique de {{month}}',
      aria: '{{condition}}, maximale {{max}}°, minimale {{min}}°',
      ariaTypical: 'Typique de {{month}} : maximale {{max}}°, minimale {{min}}°',
      at: "Mesuré à {{place}}",
      atTrip: "Mesuré à {{place}} — la destination du voyage, pas une étape de ce jour",
      tripDestination: "destination du voyage",
      panel: {
        title: 'Heure par heure',
        subtitle: 'Comment le temps évolue chaque jour du voyage',
        open: 'Voir heure par heure',
        noHourly: "Les prévisions horaires ne vont qu'à environ 9 jours.",
        noData: 'Aucune météo pour ce jour.',
        blocksLegend: "Au-delà d'environ 3 jours, les prévisions ne donnent que quatre relevés par jour, affichés tels quels. La courbe horaire complète apparaît à mesure que ces jours approchent.",
        beyondForecast: 'Au-delà des prévisions',
        precip: '{{mm}} mm',
        wind: '{{kmh}} km/h',
      },
    },
    modal: { addActivity: 'Ajouter une activité', editActivity: "Modifier l'activité", addToItinerary: "Ajouter à l'itinéraire", addToDays: 'Ajouter à {{count}} jours', dayLabel: 'Jour', addedToDay: 'Ajouté au Jour {{n}}', addedToDays: 'Ajouté à {{count}} jours', removedFromItinerary: "Retiré de l'itinéraire", itinerarySaved: 'Itinéraire mis à jour', unassignHint: "Désélectionnez un jour pour le retirer de l'itinéraire.", noDaysYet: "Aucun jour d'itinéraire.", noDaysDesc: "Ajoutez des jours dans l'onglet Itinéraire d'abord." },
    ai: { open: "Ouvrir l'assistant IA", close: "Fermer l'assistant IA" },
    activities_one: '{{count}} activité',
    activities_other: '{{count}} activités',
    flight: { outbound: 'Aller', return: 'Retour' },
    fromBooking: 'Réservation',
    fromBookingHint: 'Provient d\'une réservation de l\'onglet Réservations — modifiez-la et toutes les nuits suivent.',
    hotel: { checkIn: 'Check-in', checkOut: 'Check-out', night: 'Nuit' },
    continuesFrom: 'Continue depuis',
    startFromPrev: { active: 'Début ici', inactive: 'Démarrer depuis ici', disable: 'Arrêter de continuer depuis la veille', lastOfPrevDay: 'Dernier lieu de la veille' },
    optional: { badge: 'Optionnel', label: 'Étape optionnelle', hint: 'Si la journée déborde, vous pouvez la sauter sans souci.', mark: 'Marquer comme optionnelle', unmark: 'Marquer comme incontournable' },
    openInMaps: 'Ouvrir dans Google Maps',
    openBooking: 'Ouvrir le lien de réservation',
    delete: { title: "Supprimer l'activité ?", ariaLabel: "Supprimer l'activité", body: 'Cette action est irréversible.', bodyLocked: "Cette activité est le point de départ du lendemain — la supprimer l'enlèvera également de là." },
    bulk: { selected_one: '{{count}} sélectionnée', selected_other: '{{count}} sélectionnées', delete: 'Supprimer la sélection', cancel: 'Annuler', select: 'Sélectionner', move: 'Déplacer vers…', moveTo: 'Déplacer au jour', duplicate: 'Dupliquer vers…', duplicateTo: 'Dupliquer au jour', deleting: 'Suppression…' },
    stopCount_one: '{{count}} étape', stopCount_other: '{{count}} étapes',
    legs: { calculate_one: 'Temps de trajet ({{count}} étape)', calculate_other: 'Temps de trajet ({{count}} étapes)' },
    move: {
      dropOnDay: 'Déposez sur un jour pour l’y déplacer',
      releaseOnDay: 'Relâchez pour la déplacer au jour {{day}} · {{date}}',
      confirmTitle_one: 'Déplacer « {{title}} » au jour {{day}} ?', confirmTitle_other: 'Déplacer {{count}} étapes au jour {{day}} ?',
      confirm: 'Déplacer',
      moved_one: 'Déplacée au jour {{day}}', moved_other: '{{count}} étapes déplacées au jour {{day}}',
      duplicated_one: 'Copie créée', duplicated_other: '{{count}} copies créées',
      failed: 'Impossible de la déplacer', duplicateFailed: 'Impossible de la dupliquer',
      errorOrigin: "La carte « continue depuis » suit le jour précédent : elle ne peut pas être déplacée seule.",
      errorStayNight: "Une nuit d'hébergement n'a pas de date propre : modifiez les dates de la réservation.",
      errorBookingCard: 'Une carte générée par une réservation ne peut pas être dupliquée ; dupliquez la réservation.',
    },
    form: {
      titleField: 'Titre', titlePlaceholder: 'ex. Déjeuner à l\'Alfama',
      yourTypes: 'Vos types', newType: '+ Nouveau type…', newTypeName: 'Nom du type', newTypePlaceholder: 'ex. Snorkeling, Dégustation de vins',
      type: 'Type',
      startTime: 'Heure de début', duration: 'Durée', durationHours: 'h', durationMinutes: 'min',
      venueName: 'Nom du lieu', zone: 'Zone / Quartier',
      bookingUrl: 'URL de réservation', notes: 'Notes',
      notesPlaceholder: 'Espèces uniquement, réserver à l\'avance...',
      update: 'Mettre à jour', addActivity: 'Ajouter une activité', saveAndAddAnother: 'Enregistrer et en ajouter une autre',
      day: 'Jour',
      dayBookingHint: 'Provient d\'une réservation — changer de jour déplace aussi la réservation.',
      dayStayHint: 'Une carte par nuit — modifiez les dates du logement dans Réservations.',
      fromPlaces: 'Depuis les lieux enregistrés', filterPlaces: 'Filtrer les lieux…', noMatchPlaces: 'Aucun résultat',
    },
    types: {
      RESTAURANT: 'Restaurant', CAFE: 'Café', MONUMENT: 'Monument', VIEWPOINT: 'Belvédère',
      NEIGHBORHOOD: 'Quartier', PARK: 'Parc', SHOP: 'Boutique', EXPERIENCE: 'Expérience',
      TRANSPORT: 'Transport', PARKING: 'Parking', BEACH: 'Plage', NATURE: 'Nature', ACCOMMODATION: 'Hébergement', OTHER: 'Autre',
    },
    toast: {
      added: 'Activité ajoutée !', addedWithPlace: 'Activité ajoutée · {{name}} enregistré dans Lieux',
      updated: 'Activité mise à jour',
      deleted: 'Activité supprimée', failed: 'Échec de l\'enregistrement de l\'activité',
      loadFailed: 'Échec du chargement de l\'itinéraire', removedSuccess: 'Activité supprimée',
      movedToDay: 'Déplacée au jour {{n}}',
      optimizeFailed: "Échec de l'optimisation par l'IA", optimizeNoResult: "Impossible d'optimiser l'itinéraire",
      optimizeApplied: 'Itinéraire optimisé appliqué', reorderFailed: "Impossible d'enregistrer le nouvel ordre",
    },
    undo: { action: 'Annuler', undoLabel: 'Annuler (Ctrl+Z)', redoLabel: 'Rétablir (Ctrl+Maj+Z)', undone: 'Annulé', failed: "Impossible d'annuler — le programme a été rechargé", reordered: 'Ordre modifié', legMode: 'Mode de transport modifié' },
    empty: {
      noDays: 'Aucune journée encore',
      noDaysDesc: 'Les jours sont générés automatiquement à partir des dates du voyage. Pour en ajouter, prolongez la date de fin dans les paramètres.',
      clickDay: 'Cliquez sur un jour du voyage pour voir les activités',
      noEvents: 'Aucun événement. Ajoutez des jours et des activités d\'abord.',
      noActivities: 'Aucune activité pour l\'instant',
      addStop: 'Ajouter une étape', planWithAi: 'Planifier avec gIA', fromSaved: 'Depuis mes lieux enregistrés',
      planPrompt: 'Planifie-moi le jour {{n}} : choisis les étapes, mets-les dans un ordre logique et donne une heure à chacune.',
    },
    dow: { mon: 'Lun', tue: 'Mar', wed: 'Mer', thu: 'Jeu', fri: 'Ven', sat: 'Sam', sun: 'Dim' },
    dayUnit_one: 'JOUR', dayUnit_other: 'JOURS',
  },
  venues: {
    title: 'Lieux à visiter',
    categories: {
      RESTAURANT: 'Restaurants', CAFE: 'Cafés', ATTRACTION: 'Attractions',
      VIEWPOINT: 'Points de vue', NEIGHBORHOOD: 'Quartiers', PARK: 'Parcs',
      SHOP: 'Boutiques', EXPERIENCE: 'Expériences', TRANSPORT_HUB: 'Transports',
      BEACH: 'Plages', NATURE: 'Nature', PARKING: 'Parkings', OTHER: 'Autres',
    },
    filter: { all: 'Tous', toVisit: 'À visiter', visited: 'Visités', day: 'Jour', scheduled: 'Avec jour', unscheduled: 'Sans jour' },
    noDaySection: 'Sans jour attribué',
    progress: '{{visited}} sur {{total}} visités',
    placesCount_one: 'LIEU', placesCount_other: 'LIEUX',
    addPlace: 'Ajouter un lieu', editPlace: 'Modifier le lieu', addToItinerary: "Ajouter à l'itinéraire",
    addToDay: 'Ajouter au jour',
    mapView: 'Carte', maps: 'Maps', book: 'Réserver',
    markVisited: 'Marquer comme visité', markUnvisited: 'Démarquer comme visité', visited: 'Visité',
    viewOnMaps: 'Voir sur Google Maps',
    openNow: 'Ouvert maintenant', closedNow: 'Fermé maintenant', fullSchedule: 'Voir les horaires complets', closedDay: 'Fermé',
    hoursDisclaimer: "Les horaires peuvent ne pas être à jour à 100 % — vérifiez auprès de l'établissement.",
    showDetails: 'Voir photos et avis', showDetailsSource: '· via Google',
    detailsUnavailable: "Aucune information supplémentaire pour ce lieu.",
    deleted: 'Lieu supprimé',
    form: {
      name: 'Nom', category: 'Catégorie', address: 'Adresse',
      priceInfo: 'Prix', bookingUrl: 'URL de réservation', notes: 'Notes',
      searchPlace: 'Rechercher un lieu ou une adresse…',
      namePlaceholder: 'p.ex. Chez Marie', pricePlaceholder: 'p.ex. ~20€/personne', notesPlaceholder: 'Espèces uniquement, réserver 2 semaines avant…',
      customCategory: 'Type de lieu', customCategoryPlaceholder: 'ex. Grotte, Cave à vin, Source chaude',
      yourCategories: 'Vos catégories', newCategory: '+ Nouvelle catégorie…',
    },
    bulk: { addToDay: 'Ajouter à un jour…', scheduled_one: 'Ajouté au jour {{n}}', scheduled_other: '{{count}} lieux ajoutés au jour {{n}}' },
    noMatch: 'Aucun lieu ne correspond à ce filtre.',
    day_one: 'Jour {{days}}', day_other: 'Jours {{days}}',
    empty: { title: 'Construisez votre liste de lieux', body: 'Enregistrez chaque restaurant, monument, café et point de vue. Marquez-les comme visités au fil de votre exploration et accédez directement à Google Maps.', addFirst: 'Ajouter le premier lieu', askAi: "Demander des suggestions à l'IA" },
    delete: {
      title: 'Supprimer le lieu',
      body: 'Êtes-vous sûr de vouloir supprimer ce lieu ? Cette action est irréversible.',
      confirm: 'Supprimer',
      withStops_one: "C'est aussi une étape du jour {{days}} — cette étape part avec lui.",
      withStops_other: "C'est aussi une étape des jours {{days}} — ces étapes partent avec lui.",
    },
    toast: {
      loadFailed: 'Impossible de charger les lieux',
      deleted: 'Lieu supprimé',
      added: '{{name}} ajouté à vos lieux',
      addFailed: "Impossible d'ajouter le lieu",
      updated: 'Lieu mis à jour',
      saveFailed: 'Impossible de sauvegarder le lieu',
      suggestionAdded_one: '{{count}} nouveau lieu ajouté',
      suggestionAdded_other: '{{count}} nouveaux lieux ajoutés',
      suggestionFailed: 'Impossible de générer plus de suggestions',
      suggestionError: 'Erreur lors de la génération des suggestions',
    },
  },
  map: {
    routeError: 'Impossible de calculer l\'itinéraire', stopsCount_one: '{{count}} arrêt', stopsCount_other: '{{count}} arrêts',
    travelMode: { WALKING: 'À pied', DRIVING: 'Voiture', BICYCLING: 'Vélo', TRANSIT: 'Transport', FERRY: 'Ferry', FLIGHT: 'Vol', TRANSFER: 'Transfert', ferryLeg: '{{duration}} en ferry', unavailable: 'Non disponible pour ce tronçon', fallbackToast_one: 'Ce mode de transport n’a pas d’itinéraire ici — remplacé par un autre', fallbackToast_other: 'Aucun itinéraire dans ce mode sur {{count}} tronçons — remplacés par un autre' },
    allPlaces: 'Tous les lieux',
    dayLabel: 'Jour {{n}}',
    showOnlyCategory: 'Afficher uniquement {{label}}',
    destinationChip: { showWholeTrip: 'Voir tout le voyage', showOnly: 'Voir seulement {{name}}' },
    removeCategoryFilter: 'Retirer le filtre {{label}}',
    showAllCategories: 'Afficher toutes les catégories',
    collapsePanel: 'Réduire le panneau', expandPanel: 'Ouvrir le panneau',
    quota: { title: 'Limite mensuelle de cartes atteinte', body: 'Les lieux, itinéraires et recherches sont en pause jusqu’au renouvellement de la limite.', bodyWithDate: 'Les lieux, itinéraires et recherches sont en pause jusqu’au renouvellement de la limite, le {{date}}.', hint: 'Le reste du voyage continue de fonctionner normalement.' },
    unavailable: { title: 'Impossible de charger la carte', body: 'Google Maps n’a pas répondu. Vérifiez votre connexion et réessayez dans un instant.' },
    dayFilter: 'Jour',
    showAll: 'Tout afficher', hideAll: 'Tout masquer',
    showAllDays: "Afficher tous les jours",
    optionalStops: 'Optionnelles',
    optionalStopsHint: 'Masque les étapes optionnelles. L\'itinéraire tracé y passe toujours : la portion atténuée est ce que vous gagneriez en les sautant.',
    dayNotCalculated: "Impossible de calculer l'itinéraire de ce jour",
    scrollLeft: 'Défiler vers la gauche', scrollRight: 'Défiler vers la droite',
    searchPlaces: 'Rechercher des lieux…',
    legFromTo: 'Trajet de {{from}} à {{to}}',
    calculating: 'Calcul en cours…',
    routes: 'Itinéraires',
    daysCount_one: '{{count}} jour', daysCount_other: '{{count}} jours',
    noDaysSelected: 'Aucun jour sélectionné',
    savedPlaces: 'Lieux enregistrés', savedPlacesHint: 'Afficher les lieux enregistrés qui ne sont sur aucun itinéraire',
    showOnMap: 'Voir {{name}} sur la carte',
    places: 'Lieux', fullRoute: 'Itinéraire complet',
    calculatingRoutes: 'Calcul des itinéraires…',
    optimizing: 'Optimisation…',
    optimizeWith: 'Optimiser avec',
    optimize: 'Optimiser',
    openInMaps: 'Ouvrir dans Maps',
    recenter: 'Recentrer la carte',
    savePlaceModal: 'Enregistrer le lieu',
    addToItineraryModal: "Ajouter à l'itinéraire",
    aiOptimizePrompt: "Optimise l'ordre des étapes d'aujourd'hui pour minimiser les déplacements.",
    aiOptimizeHintPrefix: "Instructions de l'utilisateur (prioritaires sur les critères génériques)",
    aiHint: {
      title: "Instructions pour l'IA",
      subtitle: 'Optionnel. Indiquez des horaires, repas ou préférences spécifiques.',
      placeholder: 'Ex. La Sagrada Família le matin, dîner de tapas vers 21h…',
    },
    center: 'Centrer', save: 'Enregistrer',
    aiProposalTitle: 'Suggestion de parcours IA', proposedOrder: 'Ordre proposé',
    filter: 'Filtre',
    locatingPlaces: 'Localisation de vos lieux…', locationsToFind: 'lieux à trouver',
    noDaysYet: "Pas encore de jours dans l'itinéraire", addDaysFirst: "Ajoutez des jours dans l'onglet Itinéraire d'abord.",
    loadError: 'Erreur de chargement de Google Maps. Vérifiez la clé API.',
    collapseStops: 'Réduire les arrêts', expandStops: 'Développer les arrêts', tapToSeeStops: 'Appuyer pour voir les arrêts',
  },
  bookings: {
    expenses: { paid: 'Payé pour cette réservation', add: 'Ajouter une dépense' },
    types: { TRANSPORT: 'Transport', EVENT: 'Événement', ACTIVITY: 'Activité', RESTAURANT: 'Restaurant', OTHER: 'Autre' },
    title: 'Réservations et billets', subtitle: 'Vols, hôtels, transports et billets',
    sections: { flights: 'Vols', hotels: 'Hôtels et hébergements', transport: 'Transport', events: 'Événements et billets' },
    form: {
      direction: 'Direction', outbound: '→ Aller', return: '← Retour',
      from: 'Départ (IATA)', to: 'Arrivée (IATA)', departure: 'Départ', arrival: 'Arrivée',
      flightNumber: 'Numéro de vol', airline: 'Compagnie aérienne',
      bookingRef: 'Référence de réservation', notes: 'Notes',
      hotelName: 'Nom de l\'hôtel', address: 'Adresse', checkIn: 'Arrivée', checkOut: 'Départ',
      currency: 'Devise', bookingUrl: 'URL de réservation',
      category: 'Catégorie', title: 'Titre', provider: 'Fournisseur / Entreprise',
      date: 'Date', startTime: 'Heure de début', endTime: 'Heure de fin',
      startDate: 'Date de début', endDate: 'Date de fin',
      endDateHint: 'Uniquement si cela dure plusieurs jours',
      endDateBeforeStart: 'La date de fin est antérieure à la date de début',
      venue: 'Lieu / Salle', price: 'Prix', confirmed: 'Confirmé',
      documents: 'Documents (PDFs, images, e-mails)',
      saveChanges: 'Enregistrer les modifications', addFlight: 'Ajouter un vol', addHotel: 'Ajouter un hôtel', addBooking: 'Ajouter une réservation',
      legs: 'Tronçons', addLeg: 'Ajouter un tronçon', passengers: 'Passagers',
      searchPlace: 'Rechercher un lieu ou une adresse…',
      extractWithAi: 'Remplir avec l\'IA', extracting: 'Lecture du document…', addWithAi: 'Ajouter avec l\'IA',
      addWithAiTitle: 'Ajouter avec l\'IA',
      addWithAiExplanation: "Téléchargez un billet, une carte d'embarquement ou une confirmation de réservation (PDF, photo ou l'e-mail lui-même enregistré en .eml) et nous le lisons pour vous, pièces jointes comprises : dates, horaires, numéro de vol, références de réservation et plus sont remplis automatiquement. Vous pourrez tout vérifier avant d'enregistrer.",
      addWithAiDropTitle: 'Déposez votre fichier ici', addWithAiDropSubtitle: 'ou cliquez pour le rechercher — PDF, image ou e-mail (.eml)',
      unreviewedTitle_one: 'Encore 1 vol à vérifier', unreviewedTitle_other: 'Encore {{count}} vols à vérifier',
      unreviewedBody_one: 'Il a été lu dans votre document mais n\'est pas encore enregistré. Si vous fermez maintenant, il ne sera pas ajouté.',
      unreviewedBody_other: 'Ils ont été lus dans votre document mais ne sont pas encore enregistrés. Si vous fermez maintenant, ils ne seront pas ajoutés.',
      unreviewedDiscard: 'Ignorer', unreviewedKeep: 'Continuer la vérification',
      stepIndicator: 'Étape {{current}} sur {{total}}', saveAndContinue: 'Enregistrer et continuer',
      legNumber: 'Tronçon {{n}}', removeLeg: 'Supprimer le tronçon', arrivalBeforeDeparture: 'arrivée ≤ départ',
      hotelNamePlaceholder: 'Le Grand Hôtel',
      bookingTitlePlaceholder: 'ex. Renfe AVE Madrid–Barcelone',
      venuePlaceholder: 'Bernabéu, Teatro Real…',
    },
    reminder: {
      startsIn: 'Commence dans {{delay}}', endsIn: 'Se termine dans {{delay}}',
      endTitle: 'Fin · {{title}}',
      label: 'Rappel avant l\'événement', minutes: 'minutes', hours: 'heures',
      warnNoTime: 'Définissez une heure de début pour déclencher le rappel',
    },
    docs: {
      title: 'Documents', upload: 'Télécharger',
      dropHere: 'Déposez un PDF, une image ou un e-mail (.eml) ici, ou cliquez pour télécharger',
      attachFile: 'Joindre ticket, PDF, capture ou e-mail', addMore: 'Ajouter plus de fichiers',
      deleteTitle: 'Supprimer le document ?', deleteConfirm: 'Supprimer "{{name}}" ? Cette action est irréversible.',
    },
    deleteItem: {
      flightTitle: 'Supprimer le vol ?', hotelTitle: 'Supprimer l\'hôtel ?', bookingTitle: 'Supprimer la réservation ?',
    },
    empty: {
      noFlights: 'Aucun vol ajouté', noHotels: 'Aucun hôtel ajouté',
      noTransport: 'Ajoutez des trains, bus, ferries ou voitures de location',
      noEvents: 'Ajoutez des concerts, théâtre, sports, visites, restaurants…',
      addOne: 'En ajouter',
    },
    notifications: {
      blocked: 'Les notifications sont bloquées. Activez-les dans les paramètres du navigateur pour recevoir des rappels.',
      prompt: 'Activez les notifications du navigateur pour recevoir des rappels avant vos réservations.',
      enableBtn: 'Activer',
    },
    status: { outbound: 'Aller', return: 'Retour', confirmed: 'Confirmé', pending: 'En attente' },
    modal: {
      editFlight: 'Modifier le vol', addFlight: 'Ajouter un vol',
      editHotel: 'Modifier l\'hôtel', addHotel: 'Ajouter un hôtel',
      editBooking: 'Modifier la réservation', addBooking: 'Ajouter une réservation',
    },
    toast: {
      loadFailed: 'Échec du chargement des réservations', saveFailed: 'Erreur lors de l\'enregistrement',
      flightDeleted: 'Vol supprimé', hotelDeleted: 'Hôtel supprimé', bookingDeleted: 'Réservation supprimée',
      flightAdded: 'Vol ajouté', flightUpdated: 'Vol mis à jour',
      hotelAdded: 'Hôtel ajouté', hotelUpdated: 'Hôtel mis à jour',
      bookingAdded: 'Réservation ajoutée', bookingUpdated: 'Réservation mise à jour',
      fileDeleted: 'Fichier supprimé', uploadFailed: 'Échec du téléchargement',
      uploadFileFailed: "Échec de l'envoi de {{name}}",
      filesUploaded_one: '{{count}} fichier téléchargé', filesUploaded_other: '{{count}} fichiers téléchargés',
      extractSuccess: 'Détails remplis — vérifiez avant d\'enregistrer', extractFailed: 'Impossible de lire le document',
      extractNoMatch: 'Impossible d\'associer : {{names}}. Ajoutez-les manuellement.',
    },
    yourTickets: 'Vos billets',
    bookingsCount_one: 'RÉSERVATION', bookingsCount_other: 'RÉSERVATIONS',
    durationDays_one: '{{count}} jour', durationDays_other: '{{count}} jours',
    view: { sections: 'Sections', timeline: 'Chronologie' },
    timeline: { dayLabel: 'Jour {{n}}', noTickets: 'Aucun billet', ongoingDay: 'jour {{n}}/{{total}}', ongoingEnd: 'dernier jour' },
    ticket: {
      from: 'Départ', to: 'Arrivée', direct: 'Direct',
      layover_one: '{{count}} escale', layover_other: '{{count}} escales',
      layoverAt: 'Escale à {{airport}}',
    },
  },
  expenses: {
    reservationGroups: { FLIGHT: 'Vols', HOTEL: 'Hébergements', BOOKING: 'Autres réservations' },
    travellersCount_one: '{{count}} VOYAGEUR', travellersCount_other: '{{count}} VOYAGEURS',
    title: 'Dépenses',
    ledger: 'Le grand livre',
    redistribute: {
      title: 'Nouveaux membres du voyage',
      desc_one: '{{names}} a rejoint le voyage après l’enregistrement de dépenses. Partager aussi avec lui/elle la {{count}} dépense commune précédente ?',
      desc_other: '{{names}} a rejoint le voyage après l’enregistrement de dépenses. Partager aussi avec lui/elle les {{count}} dépenses communes précédentes ?',
      apply: 'Partager avec eux',
      dismiss: 'Pas maintenant',
      done_one: '{{count}} dépense redistribuée',
      done_other: '{{count}} dépenses redistribuées',
      failed: 'Impossible de redistribuer les dépenses',
    },
    stats: { totalSpent: 'Total dépensé', expenses: 'Dépenses', biggest: 'Le plus grand' },
    subtitle_one: '{{count}} entrée', subtitle_other: '{{count}} entrées',
    addExpense: 'Ajouter une dépense', editExpense: 'Modifier la dépense',
    delete: { link: 'Supprimer la dépense', title: 'Supprimer cette dépense ?' },
    expenseCount_one: '{{count}} dépense', expenseCount_other: '{{count}} dépenses',
    splits_one: '{{count}} partage', splits_other: '{{count}} partages',
    chart: { totalSpent: 'Total dépensé', total: 'total' },
    groupBy: { all: 'Tout', byCategory: 'Par catégorie' },
    scan: {
      button: 'Scanner un reçu',
      aiButton: 'Scanner avec l’IA',
      scanning: 'Lecture…',
      success: 'Reçu lu — vérifiez les détails',
      failed: 'Impossible de lire le fichier. Saisissez-le manuellement.',
      title: 'Scanner des dépenses avec l’IA',
      explanation: 'Importez un reçu, ou une capture de votre banque ou portefeuille listant plusieurs transactions — chaque dépense trouvée revient ici pour vérification.',
      dropTitle: 'Déposez ici un reçu ou une capture',
      dropSubtitle: 'Images ou PDF · jusqu’à {{count}} fichiers',
      reviewHint_one: '{{count}} dépense détectée. Décochez ce que vous ne voulez pas et touchez une ligne pour la modifier.',
      reviewHint_other: '{{count}} dépenses détectées. Décochez ce que vous ne voulez pas et touchez une ligne pour la modifier.',
      noDescription: 'Sans description',
      noRate: 'pas de taux',
      rateFailed: 'Impossible d’obtenir le taux du jour pour {{currencies}}.',
      fixRow: 'Complétez d’abord la dépense signalée.',
      include: 'Inclure cette dépense',
      exclude: 'Exclure cette dépense',
      selectedTotal_one: '{{count}} sélectionnée',
      selectedTotal_other: '{{count}} sélectionnées',
      addSelected_one: 'Ajouter {{count}} dépense',
      addSelected_other: 'Ajouter {{count}} dépenses',
      savedCount_one: '{{count}} dépense ajoutée',
      savedCount_other: '{{count}} dépenses ajoutées',
      savedFailed_one: '{{count}} dépense n’a pas pu être enregistrée',
      savedFailed_other: '{{count}} dépenses n’ont pas pu être enregistrées',
    },
    form: {
      reservation: 'Réservation liée', reservationNone: '— Aucune —',
      description: 'Description', descriptionPlaceholder: 'ex. Réservation d\'hôtel',
      category: 'Catégorie', payment: 'Paiement', amount: 'Montant',
      currency: 'Devise', date: 'Date', status: 'Statut',
      splitBetween: 'Diviser entre', perPerson: '{{currency}} {{amount}} / personne',
      notes: 'Notes', saveChanges: 'Enregistrer les modifications', addExpense: 'Ajouter une dépense',
      paidBy: 'Payé par', you: 'Vous', noCurrencies: 'Aucun résultat',
      conversion: {
        title: 'Convertir en {{currency}}',
        loading: 'Chargement…', refresh: 'Actualiser le taux',
        manual: 'Taux indisponible — saisissez-le manuellement.',
        asOf: 'Taux du {{date}}',
      },
    },
    categories: {
      ACCOMMODATION: 'Hébergement', FLIGHTS: 'Vols', FOOD: 'Nourriture',
      ACTIVITIES: 'Activités', TRANSPORT: 'Transport',
      FUEL: 'Carburant', PARKING: 'Stationnement', CASH: 'Espèces', OTHER: 'Autre',
    },
    payment: { CARD: 'Carte', CASH: 'Espèces', TRANSFER: 'Virement' },
    status: { PAID: 'Payé', PENDING: 'En attente' },
    settlement: {
      title: 'Plan de règlement', even: 'Tout le monde est à égalité',
      allDone: 'Tous les virements confirmés', pending: '{{pending}} sur {{total}} en attente',
      allEven: 'Tout le monde est à égalité — aucun virement nécessaire !',
      confirmed: 'Confirmé', settle: 'Régler', undo: 'Annuler',
      onlySelf: 'Ajoutez plus de participants au voyage pour partager les dépenses et voir qui doit quoi.',
      payIn: 'Payer en', markSettled: 'Marquer réglée',
      rateUnavailable: 'Taux de change indisponible',
      paidAs: 'Payé comme {{amount}} {{currency}}',
    },
    budget: {
      title: 'Budgets', manage: 'Budgets', set: 'Définir les budgets', edit: 'Modifier',
      empty: 'Aucun budget défini',
      emptyDesc: 'Définissez des plafonds par total, jour, catégorie ou personne et soyez alerté avant de dépasser.',
      total: 'Total du voyage', daily: 'Par jour',
      categorySection: 'Par catégorie', personSection: 'Par personne',
      tripSection: 'Limites du voyage entier',
      tripSectionHint: 'Ces plafonds s’appliquent à tout le voyage, pas par jour.',
      dailySection: 'Plafond journalier',
      dailyHint: 'Un plafond pour chaque journée — on vous prévient quand un jour s’en approche ou le dépasse.',
      noLimit: 'Aucune limite',
      leftAmount: 'Reste {{amount}}', overAmount: 'Dépassé de {{amount}}', atLimit: 'Limite atteinte',
      worstDay: 'Pire jour : {{amount}}',
      daysOver_one: '{{count}} jour au-dessus du plafond', daysOver_other: '{{count}} jours au-dessus du plafond',
      save: 'Enregistrer les budgets', saved: 'Budgets enregistrés', failed: 'Échec de l’enregistrement des budgets',
      alertsTitle: 'Alertes de budget',
      overToast: 'Attention — vous venez de dépasser votre budget {{label}}',
      warnToast: 'Vous approchez de votre budget {{label}}',
    },
    debts: {
      title: 'Dettes réglées', recalculate: 'Recalculer',
      showSettled: 'Afficher réglées ({{count}})', hideSettled: 'Masquer réglées ({{count}})',
    },
    empty: {
      title: 'Suivez les dépenses partagées',
      desc: 'Enregistrez chaque dépense et répartissez-la entre les voyageurs. L\'app calcule qui doit quoi et vous permet de régler les dettes en un tap.',
      addFirst: 'Ajouter la première dépense',
    },
    toast: {
      settled: 'Dette réglée !', recalculated: 'Dettes recalculées', deleted: 'Dépense supprimée',
      updated: 'Dépense mise à jour !', added: 'Dépense ajoutée !',
      failedUpdate: 'Échec de la mise à jour de la dépense', failedAdd: 'Échec de l\'ajout de la dépense',
      selectParticipant: 'Sélectionnez au moins un participant', loadFailed: 'Échec du chargement des dépenses',
      rateRequired: 'Saisissez un taux de change valide',
    },
    filters: {
      button: 'Filtrer', clear: 'Effacer', day: 'Jour', category: 'Catégorie',
      paidBy: 'Payé par', remove: 'Retirer {{filter}}',
      showing_one: '{{count}} dépense', showing_other: '{{count}} dépenses',
    },
    table: {
      all: 'TOUTES', noFilter: 'Aucune dépense ne correspond au filtre',
      date: 'Date', item: 'Libellé', category: 'Catégorie', paidBy: 'Payé par', split: 'Répartition', amount: 'Montant',
      editRow: 'Modifier {{description}}',
      linkedReservation: 'Lié à une réservation',
    },
    spendingByPerson: 'Dépenses par personne',
    byPerson: {
      traveller: 'Voyageur', paid: 'Payé', share: 'Sa part', balance: 'Solde',
      formerTraveller: 'Voyageur parti',
      hint: 'Payé, c’est ce qu’il a avancé. Sa part, c’est ce que le partage lui attribue.',
    },
    spendingByDay: 'Dépenses par jour',
    byCategory: 'Par catégorie',
    whoOwesWhom: 'Qui doit à qui',
    settledCount: 'Réglé · {{count}}',
    baseCurrency: {
      title: 'Devise de base',
      desc: 'Les soldes et le budget sont affichés dans cette devise ; les dépenses dans d’autres devises y sont converties. Vous ne pouvez la changer qu’avant d’ajouter une dépense.',
      edit: 'Changer la devise de base',
      saving: 'Enregistrement…',
      saved: 'Devise de base mise à jour',
      failed: 'Impossible de mettre à jour la devise de base',
    },
  },
  info: {
    deleteTip: 'Supprimer le conseil',
    tipsSectionTitle: 'Tips',
    title: 'Conseils de voyage', subtitle: 'Conseils selon votre destination',
    tips: 'Conseils de voyage',
    heading: 'Conseils de voyage',
    quickSuggestions: 'Suggestions rapides',
    acceptAndAdd: 'Accepter et ajouter',
    discard: 'Ignorer',
    saving: 'Enregistrement…',
    tipsProposalLabel: 'Proposition · {{count}} conseils',
    tipsAdded_one: '{{count}} conseil ajouté',
    tipsAdded_other: '{{count}} conseils ajoutés',
    loadFailed: 'Impossible de charger les conseils',
    tipsGenerateFailed: 'Impossible de générer les conseils',
    tipsSaveFailed: "Impossible d'enregistrer les conseils",
    tipsAiDefault: 'Donne-moi les conseils les plus utiles pour cette destination.',
    tipsAiPlaceholder: 'Ex : conseils pour un premier voyage…',
    tipsAiMorePlaceholder: "Demande plus de conseils ou d'ajustements…",
    addTipCategoryPlaceholder: 'Catégorie',
    addTipContentPlaceholder: 'Contenu du conseil…',
    addTipBtn: 'Ajouter un conseil',
    addTipLabel: 'Ajouter un conseil',
    suggestedCategories: 'Catégories suggérées',
    tipCategories: ['Transport', 'Visas et entrée', 'Argent et distributeurs', 'Sécurité', 'Langue', 'Coutumes locales', 'Carte SIM', 'Météo'] as string[],
    tipsPrompts: ['Conseils essentiels pour cette destination', 'Transports en commun et taxis', 'Argent, pourboires et distributeurs', 'Sécurité et arnaques courantes', 'Phrases utiles en langue locale', 'Coutumes locales'] as string[],
  },
  meals: {
    savedFlash: "Enregistré",
    title: 'Repas',
    subtitle: 'Ce que vous mangez chaque jour, et ce qu\'il faut acheter pour cela.',
    slot: {
      BREAKFAST: 'Petit-déjeuner', LUNCH: 'Déjeuner', SNACK: 'Goûter',
      DINNER: 'Dîner', OTHER: 'Autre',
    },
    addTo: 'Ajouter {{slot}}',
    addAtPlace: 'Au restaurant',
    pickSaved: 'Choisir un lieu enregistré',
    placeholder: 'Pâtes au saumon, dîner chez Dill…',
    notesPlaceholder: 'Notes (facultatif)',
    linkVenue: 'Lier un lieu',
    editMeal: 'Modifier le repas',
    noVenue: 'Aucun lieu',
    searchPlace: 'Rechercher un restaurant ou un café…',
    venueHint: 'Choisissez un restaurant ou un café enregistré, ou recherchez-le : il sera ajouté aux Lieux.',
    emptyDay: 'Rien de prévu',
    ingredients: {
      title: 'Ingrédients', add: 'Ajouter un ingrédient',
      namePlaceholder: 'Saumon, pâtes…', amountPlaceholder: 'Qté', amountLabel: 'Quantité',
      unit: 'Unité', remove: 'Retirer {{name}}',
      unitMismatch: 'Ce produit est déjà compté dans une autre unité',
      editAmount: 'Changer la quantité de {{name}}',
    },
    units: { u: 'pce', g: 'g', kg: 'kg', ml: 'ml', l: 'l' },
    pantry: {
      title: 'Garde-manger',
      hint: 'Ce qui a été acheté, moins ce qu’ont mangé les repas des jours passés.',
      left: 'reste {{amount}}', missing: 'manque {{amount}}',
      planned: 'prévu {{amount}}', bought: 'acheté {{amount}}', pending: '{{amount}} sur la liste',
      addMissingFor: 'Ajouter ce qui manque de {{name}} à la liste',
      added: '{{name}} ajouté à la liste',
      addShort: 'Ajouter', onList: 'Sur la liste',
    },
    grocery: {
      setAmount: 'quantité',
      amountLabel: 'Quantité à acheter', unitLabel: 'Unité d\'achat',
      title: 'Liste de courses',
      add: 'Ajouter à la liste',
      placeholder: 'Saumon frais',
      forMeal: 'pour {{title}}',
      empty: 'Rien à acheter pour l\'instant.',
      emptyHint: 'Notez ce qu\'il faut pour les repas, et cochez-le au magasin.',
      bought_one: '{{count}} dans le panier',
      bought_other: '{{count}} dans le panier',
      clearBought: 'Vider ce qui est acheté',
      cleared_one: '{{count}} article supprimé',
      cleared_other: '{{count}} articles supprimés',
      collapse: 'Masquer la liste de courses',
      expand: 'Afficher la liste de courses',
    },
    toast: {
      created: 'Repas ajouté',
      deleted: 'Repas supprimé',
      saveFailed: 'Impossible d\'enregistrer le repas',
      deleteFailed: 'Impossible de supprimer le repas',
      groceryFailed: 'Impossible d\'enregistrer la liste de courses',
      stopFailed: "Impossible de mettre à jour l'étape de l'itinéraire",
    },
    // ADR-0024: a meal linked to a stop of its day.
    stop: {
      pick: "Lier à une étape…",
      create: "Ajouter à l'itinéraire",
      timePlaceholder: "Heure",
      hint: "Lié à une étape, le titre et le lieu restent les mêmes des deux côtés.",
      linked: "Dans l'itinéraire",
      linkedAt: "Dans l'itinéraire à {{time}}",
      otherDay: "Son étape est au jour {{day}}",
      unlink: "Délier",
      badge: "Plan",
    },
    deleteLinked: {
      title: "Ce repas est une étape de l'itinéraire",
      body: "Supprimer aussi l'étape ?",
      only: "Seulement le repas",
    },
  },
  packing: {
    outfits: {
      heading: "Tenues par jour",
      hint: "Prévois ce que tu porteras chaque jour avec les vêtements de ta valise. Sépare la journée en moments seulement si ça aide (plage, dîner…).",
      piecePlaceholder: "Écris ou choisis un vêtement…",
      addNew: "Ajouter « {{text}} » à ta valise",
      addNewTo: "Ajouter « {{text}} » à {{section}}",
      sectionEmpty: "Plus rien dans cette section — écris un vêtement pour l’ajouter.",
      fromSection: "De la section",
      suitcaseEmpty: "Pas encore de vêtements dans ta valise — écris un vêtement pour l’ajouter.",
      addPiece: "Ajouter des vêtements",
      addGroup: "Séparer par moments de la journée",
      groupPrompt: "Pour quel moment ?",
      groupPresets: ["Plage", "Dîner", "Sport", "Randonnée", "Soirée"],
      dragHint: "Fais-le glisser vers un autre moment",
      allDay: "Toute la journée",
      groupPlaceholder: "Un autre moment…",
      groupName: "Nom du moment",
      renameGroup: "Renommer le moment",
      deleteGroup: "Retirer le moment",
      deleteGroupHint: "Ses vêtements reviennent à « Toute la journée »",
      removePiece: "Retirer {{text}} de ce jour",
      packed: "Dans la valise",
      notPacked: "Pas encore dans la valise",
      pieceCount_one: "{{count}} vêtement",
      pieceCount_other: "{{count}} vêtements",
      emptyDay: "Rien de prévu",
      loadFailed: "Impossible de charger les tenues par jour",
      addFailed: "Impossible d’ajouter le vêtement",
    },
    addSuggested_one: 'Ajouter {{count}} section',
    addSuggested_other: 'Ajouter {{count}} sections',
    addSectionFailed: 'Impossible d’ajouter la section',
    scope: {
      mine: 'La mienne', common: 'Commune', someone: 'Quelqu’un',
    },
    sharing: {
      on: 'Visible par le groupe', off: 'Moi uniquement',
      onHint: 'Les autres voient votre valise. Cliquez pour la garder pour vous.',
      offHint: 'Vous seul voyez votre valise. Cliquez pour la partager avec le groupe.',
      nowShared: 'Votre valise est maintenant visible par le groupe',
      nowPrivate: 'Votre valise est maintenant privée',
      failed: 'Impossible de changer qui voit votre valise',
    },
    copy: {
      button: 'Copier d’un autre voyage',
      title: 'Copier des rubriques de valise',
      pickTrip: 'De quel voyage voulez-vous copier ?',
      noTrips: 'Vous n’avez pas encore d’autre voyage à copier.',
      backToTrips: 'Choisir un autre voyage',
      pickSections: 'Rubriques à copier',
      items_one: '{{count}} article',
      items_other: '{{count}} articles',
      selectAll: 'Tout sélectionner',
      clearAll: 'Tout enlever',
      nothingToCopy: 'Ce voyage n’a pas encore de rubrique de valise remplie.',
      mergeHint: 'Les rubriques du même nom sont fusionnées et ce que vous avez déjà n’est pas dupliqué.',
      confirm_one: 'Copier {{count}} rubrique',
      confirm_other: 'Copier {{count}} rubriques',
      copying: 'Copie en cours…',
      done_one: '{{count}} article ajouté',
      done_other: '{{count}} articles ajoutés',
      nothingNew: 'Tout cela était déjà dans votre liste',
      loadFailed: 'Impossible de charger la valise de ce voyage',
      failed: 'Impossible de copier les rubriques',
    },
    assignee: { label: 'Qui l’apporte', nobody: 'Personne pour l’instant' },
    readOnlyHint: 'La valise de quelqu’un d’autre : vous pouvez la voir, mais pas la modifier.',
    emptySection: 'Rien ici pour l’instant',
    completedProgress: '{{done}}/{{total}} terminé · {{pct}}%',
    title: 'Bagages', subtitle: 'Votre checklist de bagages',
    checklists: 'Checklists pré-voyage',
    heading: 'Bagages',
    quickSuggestions: 'Suggestions rapides',
    acceptAndAdd: 'Accepter et ajouter',
    discard: 'Ignorer',
    saving: 'Enregistrement…',
    packingProposalLabel: 'Proposition · {{sections}} sections · {{items}} items',
    sectionsAdded_one: '{{count}} section ajoutée à votre liste',
    sectionsAdded_other: '{{count}} sections ajoutées à votre liste',
    sectionRemoved: 'Section supprimée',
    loadFailed: 'Impossible de charger les bagages',
    packingGenerateFailed: 'Impossible de générer la liste de bagages',
    packingGenerateSaveFailed: "Impossible d'enregistrer la liste de bagages",
    packingAiDefault: 'Génère une liste de bagages complète et personnalisée.',
    packingAiPlaceholder: 'Ex : Pour une femme, voyage de 5 jours en été…',
    packingAiMorePlaceholder: "Demande plus de sections ou d'ajustements…",
    suggestedSections: 'Sections suggérées',
    newSectionPlaceholder: 'Nouvelle section (ex : Documents, Réservations…)',
    addSection: 'Section',
    addSectionLabel: 'Ajouter une section',
    addItemPlaceholder: 'Ajouter un élément…',
    addItemBtn: 'Ajouter',
    done: 'Fait ✓',
    packingPrompts: ['Pour homme', 'Pour femme', 'Famille avec enfants', "Voyage d'affaires", 'Sac à dos', 'Plage / été', 'Montagne / randonnée'] as string[],
    defaultSectionNames: ['Documents', 'Vêtements', 'Trousse de toilette', 'Électronique', 'Médicaments', 'Réservations', 'Argent'] as string[],
    sectionAiButton: 'Générer des éléments avec l\'IA',
    sectionAiPlaceholder: 'Optionnel : nombre de jours, climat, activités prévues…',
    sectionAiGenerate: 'Générer',
    sectionAiPrompt: 'Génère UNIQUEMENT de nouveaux éléments à ajouter à la section de la liste de bagages "{{title}}" pour ce voyage. Contexte supplémentaire de l\'utilisateur : {{info}}. Ne répète pas les éléments déjà présents dans la liste : {{existing}}. Retourne une seule section nommée exactement "{{title}}" contenant uniquement les nouveaux éléments.',
    sectionAiNoExtraInfo: 'aucun fourni',
    sectionAiNoExistingItems: 'aucun pour le moment',
    sectionAiAdded_one: '{{count}} élément ajouté à "{{title}}"',
    sectionAiAdded_other: '{{count}} éléments ajoutés à "{{title}}"',
    sectionAiEmpty: "L'IA n'a suggéré aucun nouvel élément pour cette section",
    sectionAiFailed: 'Échec de la génération des éléments — réessayez',
    dragHandle: 'Glissez pour réorganiser',
    reorderFailed: 'Impossible d\'enregistrer le nouvel ordre',
    deleteSection: 'Supprimer la section',
    deleteItem: 'Supprimer l\'élément',
    editItem: 'Cliquer pour modifier',
    renameItemFailed: 'Impossible de renommer l\'élément',
    checkItem: 'Marquer comme préparé',
    uncheckItem: 'Marquer comme non préparé',
  },
  shared: {
    viewOnly: 'Voyage partagé (lecture seule)',
    noDiary: 'Rien d’écrit dans le journal pour l’instant.',
    follow: { title: 'Suivre ce voyage', hintAccount: 'Nous vous préviendrons dans l’app quand le groupe écrit dans le journal.', hintEmail: 'Recevez un e-mail quand le groupe écrit dans le journal.', follow: 'Suivre', following: 'Suivi', followed: 'Vous suivez ce voyage', unfollowed: 'Vous ne suivez plus ce voyage', error: 'Un problème est survenu. Réessayez.', emailPlaceholder: 'Votre e-mail', subscribe: 'Me prévenir', checkInbox: 'Vérifiez votre boîte mail pour confirmer.', confirmed: 'C’est fait ! Nous vous écrirons quand il y aura du nouveau.', unsubscribed: 'Vous ne recevrez plus d’e-mails sur ce voyage.', linkExpired: 'Ce lien ne fonctionne plus.' },
    notFoundTitle: 'Voyage introuvable',
    notFoundDesc: "Ce lien de partage est invalide ou le propriétaire a désactivé le partage.",
    nights_one: '{{count}} nuit', nights_other: '{{count}} nuits',
    traveller_one: '{{count}} voyageur', traveller_other: '{{count}} voyageurs',
    sections: {
      diary: 'Journal',
      flights: 'Vols', accommodation: 'Hébergement', itinerary: 'Itinéraire', about: 'À propos du voyage',
      places: 'Lieux', map: 'Carte', travel: 'Voyage',
      tips: 'Conseils', photos: 'Photos', meals: 'Repas', bookings: 'Réservations',
    },
    footer: 'Partagé avec Gromly · Lecture seule',
    outbound: 'Aller', return: 'Retour', noActivities: 'Aucune activité planifiée',
    optional: 'Facultatif',
    noPlaces: 'Aucun lieu enregistré.', noTips: 'Pas encore de conseils.', noPhotos: 'Pas encore de photos.', noBookings: 'Rien de réservé pour l’instant.',
    openInMaps: 'Ouvrir dans Google Maps',
    map: {
      allPlaces: 'Tous les lieux', dayByDay: 'Jour par jour', dayLabel: 'Jour {{n}}',
      unavailable: 'Carte indisponible', noRouteYet: 'L’itinéraire de cette journée n’a pas encore été calculé.',
    },
  },
  account: {
    storage: { title: "Stockage", photos: "Photos", used: "{{used}} sur {{quota}}", full: "Ton espace photos est plein. Supprime des photos pour en envoyer de nouvelles." },
    avatar: { change: "Changer la photo", add: "Ajouter une photo", remove: "Supprimer la photo", cropTitle: "Cadrez votre photo", zoom: "Zoom", save: "Enregistrer la photo", saved: "Photo de profil mise à jour", removed: "Photo de profil supprimée", failed: "Impossible de mettre à jour votre photo", unsupported: "Ce fichier n'est pas une photo utilisable" },
    birthDate: "Date de naissance", birthDateHint: "Vous seul la voyez. Vos voyages ne voient que votre âge, pour vous signaler les tarifs et avantages selon l'âge.", birthDateSaved: "Date de naissance enregistrée", birthDateSaveFailed: "Impossible d'enregistrer votre date de naissance",
    nationality: "Nationalité", nationalitySaveFailed: "Impossible de mettre à jour la nationalité",
    title: 'Compte',
    subtitle: 'Gérez votre profil et vos préférences',
    profile: 'Profil',
    memberSince: 'Membre depuis',
    credits: 'Crédits',
    tripCredits: 'Crédits voyage',
    aiCredits: 'Crédits IA',
    plan: { title: "Formule", gift: "Offert par Gromly", free: "Gratuite", proUntil: "PRO jusqu'au {{date}}", manage: "Gérer l'abonnement", inStore: "Gérez-le dans {{store}}", upgrade: "Passer à PRO", restore: "Restaurer les achats", restored: "Achats restaurés", nothing: "Aucun achat à restaurer" },
    security: 'Sécurité',
    changePassword: {
      title: 'Changer le mot de passe',
      rowHint: 'Modifiez le mot de passe utilisé pour vous connecter',
      setTitle: 'Définir un mot de passe',
      setHint: 'Votre compte n’a pas encore de mot de passe',
      setLinkSent: 'Nous vous avons envoyé un lien pour définir un mot de passe.',
      setLinkFailed: "Impossible d'envoyer le lien. Réessayez dans quelques minutes.",
      current: 'Mot de passe actuel',
      new: 'Nouveau mot de passe',
      confirm: 'Répétez le nouveau mot de passe',
      signsOutOthers: 'Vous resterez connecté ici, mais tous les autres appareils seront déconnectés.',
      submit: 'Changer le mot de passe',
      success: 'Mot de passe modifié.',
      wrongCurrent: "Ce n'est pas votre mot de passe actuel.",
      unchanged: "Le nouveau mot de passe est identique à l'actuel.",
      googleAccount: 'Ce compte se connecte avec Google. Utilisez le lien envoyé par email pour définir un mot de passe.',
      failed: 'Impossible de changer votre mot de passe. Réessayez.',
    },
    twoFactor: 'Authentification à deux facteurs',
    enabled: 'Activé',
    notEnabled: 'Non activé',
    data: 'Données et confidentialité',
    exportData: 'Exporter mes données',
    exportDataDesc: 'Télécharger une copie de toutes vos données',
    danger: 'Zone de danger',
    signOut: 'Se déconnecter',
    deleteAccount: 'Supprimer le compte',
    deleteAccountDesc: 'Supprimer définitivement votre compte et toutes vos données',
    deleteConfirmTitle: 'Supprimer le compte',
    deleteConfirmSubtitle: 'Cette action est permanente',
    deleteConfirmBody: 'Tous vos voyages, dépenses, réservations et données personnelles seront supprimés définitivement. Cette action est irréversible.',
    deleting: 'Suppression…',
    deletePermanently: 'Supprimer définitivement',
    saveFirst: "Vous voulez d'abord sauvegarder vos données ?",
    exportFailed: 'Impossible d\'exporter les données. Veuillez réessayer.',
    deleteFailed: 'Impossible de supprimer le compte. Veuillez réessayer.',
  },
  docs: {
    hero: {
      title: 'Documentation de Gromly',
      subtitle: 'Tout ce que vous devez savoir pour planifier, collaborer et voyager avec Gromly.',
      back: 'Retour au tableau de bord',
    },
    sidebar: { sections: 'Sections' },
    footer: { title: 'Prêt à planifier ?', subtitle: 'Retournez à votre tableau de bord et créez votre premier voyage.', cta: 'Aller au tableau de bord' },
    itinerary: {
      title: 'Itinéraire', subtitle: 'Planifiez vos journées, heure par heure',
      p1: "L'itinéraire est le cœur de votre voyage. Ajoutez des activités à chaque jour, réorganisez-les en les faisant glisser, et chaque nouveau jour continue automatiquement là où le précédent s'est terminé.",
      feat_addDay_label: 'Ajouter un jour', feat_addDay_desc: 'Cliquez sur "Ajouter un jour" pour créer un nouveau jour. Les dates sont attribuées automatiquement à partir de la date de début du voyage.',
      feat_drag_label: 'Glisser-déposer', feat_drag_desc: "Réorganisez les activités au sein d'une journée en faisant glisser la poignée.",
      feat_ai_label: "Planification avec l'IA", feat_ai_desc: "Cliquez sur le bouton IA pour ouvrir le chat. Demandez-lui d'ajouter des activités, de suggérer quoi visiter ou de déplacer des éléments.",
      tip1: "Basculez entre les vues Liste et Chronologie avec le sélecteur dans l'en-tête. La vue Chronologie fusionne vols, hôtels et activités dans un seul fil chronologique.",
      step1: 'Cliquez sur "Ajouter un jour" pour créer votre première journée.',
      step2: 'Cliquez sur "+ Ajouter une activité" pour ajouter des activités à la journée.',
      step3: 'Remplissez le titre, le type (Restaurant, Monument, etc.) et les détails facultatifs.',
      step4: "Faites glisser les activités pour les réorganiser dans la journée.",
    },
    places: {
      title: 'Lieux', subtitle: 'Votre liste de souhaits personnelle pour la destination',
      p1: "Lieux est votre liste curatée d'endroits à visiter : restaurants à essayer, monuments à voir, quartiers à explorer, boutiques à parcourir. Tout est organisé par catégorie.",
      feat_add_label: 'Ajouter un lieu', feat_add_desc: 'Utilisez le bouton "+ Ajouter un lieu" ou demandez à l\'IA de l\'ajouter avec enrichissement automatique Google Maps.',
      feat_visited_label: 'Marquer comme visité', feat_visited_desc: "Touchez la coche sur la carte du lieu une fois que vous y êtes allé. Les lieux visités sont grisés mais conservés dans votre liste.",
      feat_ai_label: "Recommandations de l'IA", feat_ai_desc: "Ouvrez le chat IA et demandez \"Donnez-moi 5 recommandations de restaurants dans le vieux quartier\". Il les ajoutera directement à votre liste.",
      tip1: "Les lieux ajoutés ici apparaissent automatiquement comme options d'épingle dans l'onglet Carte. Vous pouvez relier un lieu directement à une activité de l'itinéraire avec le bouton \"Ajouter à l'itinéraire\".",
    },
    map: {
      title: 'Carte', subtitle: 'Visualisez les itinéraires et optimisez votre journée',
      p1: "L'onglet Carte affiche tous vos lieux sauvegardés sous forme d'épingles. Sélectionnez un jour dans le menu déroulant pour voir uniquement les activités de ce jour avec un itinéraire tracé entre elles.",
      feat_route_label: 'Itinéraire du jour', feat_route_desc: "Sélectionnez un jour pour voir un itinéraire connecté entre toutes les activités dans l'ordre. Touchez une épingle pour voir les détails.",
      feat_reorder_label: 'Réorganiser les étapes', feat_reorder_desc: "Dans le panneau d'itinéraire, faites glisser les étapes pour changer leur ordre. L'itinéraire sur la carte se met à jour en temps réel.",
      feat_ai_label: "Optimiser avec gIA", feat_ai_desc: "Touchez \"Optimiser avec gIA\" pour laisser l'IA réorganiser vos étapes géographiquement afin de minimiser les allers-retours.",
      tip1: "Sur mobile, le panneau d'itinéraire glisse depuis le bas comme une feuille. Faites-le glisser vers le bas pour le masquer et obtenir une vue carte plein écran.",
    },
    bookings: {
      title: 'Réservations', subtitle: 'Vols, hôtels, transports et billets — tout en un endroit',
      p1: "Réservations centralise toutes les réservations de votre voyage : vols aller et retour, check-ins hôtel, trajets de transport (train, bus, taxi) et billets pour événements ou activités.",
      feat_flights_label: 'Vols', feat_flights_desc: "Ajoutez des vols aller et retour avec compagnie aérienne, numéro de vol, aéroports de départ/arrivée et référence de réservation.",
      feat_hotels_label: 'Hôtels', feat_hotels_desc: "Enregistrez votre hébergement avec les dates d'arrivée et de départ, l'adresse et l'URL de réservation.",
      feat_bookings_label: 'Réservations et billets', feat_bookings_desc: "Ajoutez n'importe quelle autre réservation : théâtre, match de football, entrée musée, billet de bus — avec date, lieu et référence.",
      feat_docs_label: 'Joindre des documents', feat_docs_desc: "Téléchargez des PDFs, captures d'écran, photos ou l'e-mail de confirmation lui-même (.eml) directement sur une réservation. Stockés en toute sécurité dans le cloud.",
      tip1: "Enregistrez l'e-mail de confirmation en .eml et téléchargez-le tel quel : l'IA lit le message et les billets qui y sont joints, et vous l'avez accessible hors ligne. L'app affichera un rappel 48 heures avant chaque vol ou check-in hôtel.",
      warning1: "Les téléchargements de documents nécessitent que Cloudflare R2 soit configuré dans l'environnement serveur. Contactez votre administrateur si le bouton de téléchargement est désactivé.",
    },
    expenses: {
      title: 'Dépenses et budget', subtitle: 'Suivez les dépenses et réglez les dettes automatiquement',
      p1: "L'onglet Dépenses est un tracker complet de dépenses de groupe. Enregistrez ce qui a été dépensé, qui a payé, comment c'est réparti dans le groupe, et laissez l'app calculer la façon la plus simple de régler.",
      feat_add_label: 'Ajouter une dépense', feat_add_desc: "Enregistrez qui a payé, le montant, la devise, la catégorie (Hébergement, Nourriture, Transport…) et comment le diviser.",
      feat_settle_label: 'Règlement automatique', feat_settle_desc: 'Cliquez sur "Recalculer" pour obtenir l\'ensemble minimal de paiements qui règle toutes les dettes.',
      feat_debt_label: 'Régler une dette', feat_debt_desc: "Une fois une dette réglée dans la vraie vie, touchez \"Régler\" pour la marquer comme faite. Les dettes réglées sont conservées pour référence.",
      feat_budget_label: 'Tracker de budget', feat_budget_desc: "Touchez l'icône crayon sur la carte Budget pour définir un budget total. Une barre de progression montre combien vous avez utilisé par catégorie.",
      tip1: "La barre de budget devient ambre quand vous atteignez 80% de votre budget et rouge quand vous le dépassez. Définissez-la au début du voyage pour toujours savoir où vous en êtes.",
      step1: 'Ouvrez Dépenses et cliquez sur "Ajouter une dépense".', step2: 'Sélectionnez qui a payé et le montant.',
      step3: 'Choisissez comment diviser : également entre tous les participants, ou montants personnalisés.',
      step4: 'Après avoir ajouté plusieurs dépenses, cliquez sur "Recalculer" pour obtenir le plan de règlement.',
      step5: 'Quand un paiement est effectué, touchez "Régler" pour clôturer la dette.',
    },
    info: {
      title: 'Info et conseils', subtitle: 'Conseils, checklists et connaissance locale',
      p1: "Info et Conseils a deux sections : un tableau libre de conseils organisé par catégorie (Transport, Nourriture, Culture, Argent…) et des checklists pré-voyage pour faire les bagages et se préparer.",
      feat_tips_label: 'Conseils', feat_tips_desc: 'Ajoutez de courts conseils par catégorie. Idéal pour des notes comme "Le métro ferme à minuit" ou "Réservez les restaurants 2 semaines à l\'avance".',
      feat_checklists_label: 'Checklists', feat_checklists_desc: "Créez des sections de checklist (Documents, Vêtements, Électronique…) et ajoutez des éléments à chacune. Cochez-les en faisant vos bagages.",
      feat_ai_label: "Liste de bagages avec l'IA", feat_ai_desc: "Cliquez sur \"Générer avec l'IA\" pour obtenir une liste de bagages personnalisée selon votre destination, durée, saison et activités planifiées.",
      tip1: "La liste de bagages avec l'IA est générée sous forme de sections de checklist afin que vous puissiez la modifier, ajouter ou supprimer des éléments par la suite. C'est un point de départ, pas une liste fixe.",
      step1: 'Ajoutez une section checklist (ex. "Documents") avec le champ de texte en bas.',
      step2: "Tapez les éléments un par un et appuyez sur Entrée pour les ajouter.",
      step3: "Ou cliquez sur \"Générer avec l'IA\" pour créer automatiquement une liste de bagages complète.",
      step4: "En faisant vos bagages, cochez les éléments. La barre de progression en haut suit l'avancement.",
    },
    ai: {
      title: "Assistant IA", subtitle: 'Votre compagnon de voyage intelligent',
      p1: "L'assistant IA est conscient du contexte — il connaît votre destination, les dates du voyage et ce qui se trouve déjà dans votre voyage. Il fonctionne différemment selon l'onglet dans lequel vous vous trouvez.",
      feat_places_label: 'Mode Lieux', feat_places_desc: "Ajoutez \"La Sagrada Família à mes lieux\" et il la trouvera sur Google Maps, remplira l'adresse et créera le lieu automatiquement.",
      feat_itinerary_label: "Mode Itinéraire", feat_itinerary_desc: "Demandez-lui d'ajouter des activités à des jours et tranches horaires spécifiques, ou de déplacer des activités existantes. Il voit votre itinéraire actuel.",
      feat_route_label: 'Mode Itinéraire', feat_route_desc: "Dans l'onglet Carte, demandez-lui de réorganiser les étapes du jour sélectionné, en minimisant le temps de trajet entre les zones.",
      feat_packing_label: 'Mode Bagages', feat_packing_desc: "Dans Info et Conseils, génère une liste de bagages complète adaptée à votre destination, saison et types d'activités.",
      tip1: "Parlez à l'IA dans n'importe quelle langue — elle répond dans la langue que vous utilisez. Soyez précis : \"Ajoutez 3 bars à tapas près du Quartier Gothique pour le dîner\" fonctionne mieux qu'\"Ajoutez des restaurants\".",
      warning1: "L'IA nécessite une clé API OpenAI configurée sur le serveur. Si le bouton de chat IA est grisé ou renvoie une erreur, demandez à votre administrateur de vérifier la clé API.",
    },
    sharing: {
      title: 'Partager le voyage', subtitle: "Permettre à n'importe qui de voir votre voyage sans compte",
      p1: "La fonctionnalité Partager le voyage génère un lien public unique permettant à n'importe qui — même sans compte — de voir votre voyage en lecture seule : itinéraire, vols, hôtels et notes.",
      feat_enable_label: 'Activer le partage', feat_enable_desc: "Dans la barre latérale du voyage, cliquez sur \"Partager le voyage\" puis \"Activer le partage\". Une URL unique est générée immédiatement.",
      feat_copy_label: 'Copier le lien', feat_copy_desc: "Copiez le lien et envoyez-le à des proches ou amis. Ils peuvent voir l'itinéraire complet mais ne peuvent rien modifier.",
      feat_disable_label: 'Désactiver le partage', feat_disable_desc: "Cliquez sur \"Désactiver le partage\" à tout moment pour invalider le lien. Quiconque possède l'ancienne URL verra une page \"Introuvable\".",
      tip1: "La vue partagée est une page propre et adaptée au mobile sans connexion requise. Parfait pour envoyer l'itinéraire à un proche qui souhaite suivre votre voyage.",
      warning1: "Seul le propriétaire du voyage peut activer ou désactiver le partage. Les participants avec les rôles EDITOR ou VIEWER ne peuvent pas gérer le lien de partage.",
    },
    participants: {
      title: 'Participants', subtitle: 'Invitez et gérez votre groupe de voyage',
      p1: "Invitez des co-voyageurs pour collaborer sur le voyage. Chaque participant a un rôle qui contrôle ce qu'il peut faire.",
      feat_invite_label: 'Inviter par email', feat_invite_desc: "L'invité doit déjà avoir un compte. Entrez son email et choisissez un rôle.",
      feat_editor_label: 'Rôle EDITOR', feat_editor_desc: "Peut ajouter, modifier et supprimer du contenu : activités, lieux, dépenses, réservations, conseils et checklists.",
      feat_viewer_label: 'Rôle VIEWER', feat_viewer_desc: "Accès lecture seule. Peut tout voir mais ne peut pas faire de modifications. Idéal pour quelqu'un qui veut suivre le plan.",
      tip1: "Seul le propriétaire peut inviter des participants, changer leur rôle ou les supprimer. Le propriétaire est aussi le seul à pouvoir supprimer l'intégralité du voyage.",
      step1: "Dans la barre latérale du voyage, cliquez sur le bouton participants (affiche les avatars et le nombre de membres). Sur mobile, touchez l'icône des personnes dans l'en-tête du voyage.",
      step2: 'Cliquez sur "Inviter un participant" et entrez l\'adresse email.',
      step3: 'Choisissez EDITOR (peut modifier) ou VIEWER (lecture seule).',
      step4: 'Le participant verra le voyage dans son tableau de bord immédiatement.',
    },
    notifications: {
      title: 'Notifications', subtitle: "Rappels in-app pour les événements à venir",
      p1: "L'app affiche des rappels in-app lorsqu'un départ de vol ou un check-in hôtel est dans les 48 prochaines heures. Aucun réglage nécessaire — ça fonctionne automatiquement.",
      feat_flights_label: 'Rappels de vols', feat_flights_desc: "Affichés 48h avant le départ. Urgent (rouge) dans les 12 heures.",
      feat_hotels_label: "Rappels d'hôtel", feat_hotels_desc: "Affichés 48h avant le check-in. Urgent (rouge) dans les 12 heures.",
      feat_where_label: 'Où les trouver', feat_where_desc: "Bureau : panneau ambre dans la barre latérale du voyage. Mobile : badge rouge sur l'onglet Réservations dans la barre de navigation inférieure.",
      tip1: "Les rappels sont calculés à partir de vos vols et hôtels dans l'onglet Réservations. Assurez-vous d'ajouter vos heures de départ réelles pour recevoir des alertes précises.",
    },
    community: {
      title: 'Explorer la communauté', subtitle: 'Découvrez, notez et clonez des voyages d\'autres voyageurs',
      p1: 'La section Explorer est un flux public de voyages partagés par la communauté Gromly. Parcourez des destinations, découvrez des itinéraires créés par de vrais voyageurs et clonez n\'importe quel voyage comme point de départ.',
      feat_browse_label: 'Parcourir et rechercher', feat_browse_desc: 'Filtrez par destination ou durée, et triez par Plus récents, Mieux notés ou Plus utilisés. Utilisez la barre de recherche pour une destination précise.',
      feat_clone_label: 'Cloner un voyage', feat_clone_desc: 'Cliquez sur "Utiliser cet itinéraire" pour créer une copie complète dans votre tableau de bord. Le clone est indépendant — vos modifications n\'affectent pas l\'original.',
      feat_rate_label: 'Noter des voyages', feat_rate_desc: 'Laissez une note de 1 à 5 étoiles sur n\'importe quel voyage publié. Les notes aident à mettre en avant les meilleurs itinéraires.',
      feat_follow_label: 'Suivre des voyageurs', feat_follow_desc: 'Suivez d\'autres utilisateurs pour filtrer le flux sur leurs voyages uniquement. Utilisez l\'onglet "Abonnements" pour voir leurs dernières publications.',
      tip1: 'Pour publier votre propre voyage, allez dans votre tableau de bord, ouvrez le menu du voyage (trois points) et cliquez sur "Partager avec la communauté".',
      step1: 'Allez dans Explorer depuis la barre de navigation du haut.',
      step2: 'Utilisez la barre de recherche ou les options de tri pour trouver des voyages.',
      step3: 'Cliquez sur une carte de voyage pour voir l\'itinéraire complet.',
      step4: 'Cliquez sur "Utiliser cet itinéraire" pour le cloner dans votre tableau de bord.',
    },
    account: {
      title: 'Compte et sécurité', subtitle: '2FA, contrôles de confidentialité et vos données',
      p1: 'Les paramètres de votre compte sont accessibles depuis le menu utilisateur (coin supérieur droit). Vous pouvez y gérer l\'authentification à deux facteurs, télécharger vos données et supprimer votre compte.',
      feat_2fa_label: 'Authentification à deux facteurs', feat_2fa_desc: 'Cliquez sur "Sécurité" dans le menu utilisateur pour configurer la 2FA. Scannez le QR code avec Google Authenticator, Authy ou n\'importe quelle app TOTP.',
      feat_export_label: 'Télécharger mes données', feat_export_desc: 'Cliquez sur "Télécharger mes données" pour exporter toutes vos données personnelles en JSON (RGPD Art. 20 — portabilité).',
      feat_delete_label: 'Supprimer le compte', feat_delete_desc: 'Cliquez sur "Supprimer le compte" pour supprimer définitivement votre compte et toutes les données associées. Cette action est irréversible.',
      tip1: 'Nous recommandons vivement d\'activer la 2FA — elle protège votre compte même si votre mot de passe est compromis. Utilisez Google Authenticator, Authy, 1Password, etc.',
      warning1: 'La suppression de votre compte est permanente et irréversible. Tous vos voyages, dépenses, réservations et documents seront supprimés. Téléchargez vos données d\'abord si vous souhaitez une copie.',
    },
    pwa: {
      title: "Installer comme app (PWA)", subtitle: 'Utilisez Gromly hors ligne sur n\'importe quel appareil',
      p1: "Gromly est une Progressive Web App (PWA). Vous pouvez l'installer sur votre téléphone ou ordinateur de bureau et l'utiliser comme une app native — même sans connexion internet.",
      feat_ios_label: 'Installer sur iOS', feat_ios_desc: "Ouvrez Gromly dans Safari → touchez le bouton Partager → \"Ajouter à l'écran d'accueil\". C'est fait.",
      feat_android_label: 'Installer sur Android', feat_android_desc: "Ouvrez dans Chrome → touchez le menu à trois points → \"Ajouter à l'écran d'accueil\" ou \"Installer l'app\".",
      feat_desktop_label: "Installer sur ordinateur", feat_desktop_desc: "Dans Chrome ou Edge, cherchez l'icône d'installation (➕) dans la barre d'adresse et cliquez dessus.",
      tip1: "Gromly met en cache vos voyages, itinéraire et réservations pour qu'ils se chargent instantanément même sans connexion. La consultation fonctionne hors ligne ; ajouter ou modifier quelque chose nécessite toujours une connexion.",
    },
  },
  installPrompt: {
    title: 'Installer Gromly',
    subtitle: "Ajoutez-la à votre écran d'accueil pour un accès rapide en plein écran.",
    install: 'Installer',
    iosIntro: "Pour l'installer sur votre iPhone :",
    iosStep1: 'Appuyez sur le bouton Partager',
    iosStep2: "Choisissez « Sur l'écran d'accueil »",
  },
  maps: {
    quotaExceeded: "Vous avez atteint la limite Maps de ce mois-ci. Elle se réinitialise le {{date}}.",
  },
  ai: {
    deleteActivity: "Supprimer l'activité",
    venueNotes: {
      title: 'Réécrire les notes de {{name}}', titleNew: 'Notes pour {{name}}',
      before: 'Actuel', after: 'Proposé', emptied: '(notes vidées)',
    },
    deletePlaces_one: 'Supprimer le lieu',
    deletePlaces_other: 'Supprimer {{count}} lieux',
    deleteAllPlaces_one: 'Vider la liste de lieux ({{count}} lieu)',
    deleteAllPlaces_other: 'Vider la liste de lieux ({{count}} lieux)',
    deleteTakesStops_one: "Cela retire aussi {{count}} étape de l'itinéraire",
    deleteTakesStops_other: "Cela retire aussi {{count}} étapes de l'itinéraire",
    deleteExpenses_one: 'Supprimer la dépense',
    deleteExpenses_other: 'Supprimer {{count}} dépenses',
    deleteAllExpenses_one: 'Vider le livre de comptes ({{count}} dépense)',
    deleteAllExpenses_other: 'Vider le livre de comptes ({{count}} dépenses)',
    assistant: 'Assistant IA',
    name: 'gIA',
    expand: "Ouvrir l'assistant",
    collapse: "Réduire l'assistant",
    saveFailed: 'Impossible de sauvegarder',
    someNotSaved: "Certaines propositions n'ont pas pu être sauvegardées",
    error: "Désolé, une erreur s'est produite. Veuillez réessayer.",
    clearConversation: 'Effacer la conversation',
    expenseSplitHint: 'Vous payez ; partagé à parts égales. Modifiez le détail dans Dépenses.',
    proposals_one: '{{count}} proposition',
    proposals_other: '{{count}} propositions',
    saving: 'Sauvegarde…',
    op: {
      tripDates: {
        title: 'Nouvelles dates : {{from}} → {{to}}',
        addedDays_one: '{{count}} jour est ajouté',
        addedDays_other: '{{count}} jours sont ajoutés',
        removedDays_one: '{{count}} jour est retiré',
        removedDays_other: '{{count}} jours sont retirés',
        movedStops_one: '{{count}} étape passe au jour {{day}}',
        movedStops_other: '{{count}} étapes passent au jour {{day}}',
        removedMeals_one: '{{count}} repas prévu est perdu',
        removedMeals_other: '{{count}} repas prévus sont perdus',
        removedOutfitDays_one: 'Les vêtements prévus de {{count}} jour sont perdus',
        removedOutfitDays_other: 'Les vêtements prévus de {{count}} jours sont perdus',
        outOfRange_one: '{{count}} réservation sort des nouvelles dates',
        outOfRange_other: '{{count}} réservations sortent des nouvelles dates',
      },
      settleDebt: {
        title: '{{from}} a payé {{amount}} à {{to}}',
      },
      outfitAdd: {
        title: 'Porter {{item}} le jour {{day}}',
      },
      ingredientAdd: {
        title: 'Ajouter {{amount}} {{unit}} de {{name}} à « {{meal}} »',
      },
      mealStop: {
        title: 'Mettre « {{meal}} » comme étape du jour {{day}}',
      },
      duplicate: {
        title_one: 'Copier {{count}} étape au jour {{day}}',
        title_other: 'Copier {{count}} étapes au jour {{day}}',
      },
      item: '– {{text}}',
    },
    cards: {
      empty: '(vide)',
      field: {
        title: 'Titre',
        notes: 'Notes',
        startTime: 'Heure',
        durationMins: 'Durée (min)',
        name: 'Nom',
        category: 'Catégorie',
        customCategory: 'Catégorie perso',
        zone: 'Zone',
        priceInfo: 'Prix',
        visited: 'Visité',
        airline: 'Compagnie',
        flightNumber: 'Numéro de vol',
        departureTime: 'Départ',
        arrivalTime: 'Arrivée',
        bookingRef: 'Référence',
        address: 'Adresse',
        checkIn: 'Arrivée',
        checkOut: 'Départ',
        bookingUrl: 'Lien de réservation',
        type: 'Type',
        date: 'Date',
        endDate: 'Date de fin',
        endTime: 'Heure de fin',
        venue: 'Lieu',
        description: 'Description',
        amount: 'Montant',
        content: 'Texte',
        text: 'Article',
        checked: 'Dans la valise',
        slot: 'Repas',
        bought: 'Acheté',
        unit: 'Unité',
      },
      entity: {
        day_one: 'jour', day_other: 'jours',
        venue_one: 'lieu', venue_other: 'lieux',
        flight_one: 'vol', flight_other: 'vols',
        hotel_one: 'hébergement', hotel_other: 'hébergements',
        booking_one: 'réservation', booking_other: 'réservations',
        expense_one: 'dépense', expense_other: 'dépenses',
        note_one: 'note', note_other: 'notes',
        tip_one: 'conseil', tip_other: 'conseils',
        packing_section_one: 'section de la valise', packing_section_other: 'sections de la valise',
        packing_item_one: 'article de la valise', packing_item_other: 'articles de la valise',
        outfit_piece_one: 'vêtement prévu', outfit_piece_other: 'vêtements prévus',
        meal_one: 'repas', meal_other: 'repas',
        grocery_item_one: 'article de courses', grocery_item_other: 'articles de courses',
      },
      yes: 'Oui',
      no: 'Non',
      editItem: 'Modifier « {{label}} »',
      deleteItems_one: 'Supprimer {{count}} élément',
      deleteItems_other: 'Supprimer {{count}} éléments',
      packed: '✓ {{item}} dans la valise',
      unpacked: '○ {{item}} pas encore dans la valise',
      nights_one: '{{count}} nuit',
      nights_other: '{{count}} nuits',
      at: 'À {{place}}',
      editStop: 'Modifier « {{title}} »',
      packingItems: 'Valise',
      note: 'Note',
      day: 'Jour {{n}}',
      grocery: 'Liste de courses',
      flight: 'Vol',
      stay: 'Hébergement',
      booking: 'Réservation',
    },
    acceptAll: 'Tout accepter',
    accept: 'Accepter',
    discard: 'Ignorer',
    sendHint: 'Entrée pour envoyer · Maj+Entrée nouvelle ligne',
    open: 'Ouvert',
    closed: 'Fermé',
    willSaveToPlaces: 'Ajouté aux Lieux',
    move: 'Déplacer : {{title}}',
    afterStop: 'après {{title}}',
    placeholder: {
      places: '"Je veux sauvegarder un restaurant dans le Quartier Gothique"',
      itinerary: '"Ajoute une visite à la Sagrada Família le jour 2"',
      allroutes: '"Rends le jour 2 une route circulaire" ou "Supprime l\'arrêt du musée"',
      packing: '"Propose une liste de bagages" ou "Ajoute une section plage"',
      tips: '"Donne-moi des conseils sur le transport et l\'argent"',
      bookings: '"Combien de temps entre mes vols de correspondance ?"',
      expenses: '"Combien avons-nous dépensé en nourriture ?" ou "Qui doit à qui ?"',
      general: "\"Planifie-moi le jour 3\" ou \"Qu'est-ce que j'emporte ?\"",
    },
    welcome: {
      places: "Bonjour ! Parlez-moi des endroits que vous souhaitez enregistrer et je vous les proposerai pour votre liste de lieux.",
      itinerary: "Bonjour ! Je peux suggérer des activités pour votre itinéraire ou les déplacer. C'est vous qui décidez.",
      allroutes: "Bonjour ! Je peux réorganiser les arrêts pour minimiser les déplacements, créer des itinéraires circulaires, déplacer des activités entre les jours ou en supprimer. C'est vous qui décidez.",
      packing: "Bonjour ! Je peux vous proposer une liste de bagages adaptée à votre voyage. C'est vous qui décidez de l'accepter.",
      tips: "Bonjour ! Je peux vous proposer des conseils pratiques pour votre destination. C'est vous qui décidez de les garder.",
      bookings: "Bonjour ! Demandez-moi tout sur vos vols et hôtels : horaires, correspondances, enregistrement et logistique.",
      expenses: "Bonjour ! Posez-moi vos questions sur vos dépenses, votre budget et les soldes : totaux par catégorie, qui doit à qui ou comment partager les frais.",
      general: "Bonjour ! Demande-moi ce que tu veux sur ton voyage : lieux, programme, valise, réservations ou dépenses. C'est toi qui décides ce que tu gardes.",
    },
    // The vocabulary that unlocks the assistant, made visible: an empty
    // input box teaches nobody what it can do.
    suggestions: {
      general: ["Planifie-moi le jour 1", "Propose-moi des lieux pour mes centres d'intérêt", "Qu'est-ce que j'emporte ?"],
      places: ["Propose-moi des lieux pour mes centres d'intérêt", "Où bien manger pas cher", "Que faire s'il pleut"],
      itinerary: ["Planifie-moi le jour 1", "Cette journée est trop chargée", "Ajoute un dîner le jour 2"],
      allroutes: ["Optimise l'itinéraire de ce jour", "Rends-le circulaire", "Déplace cette étape à un autre jour"],
      packing: ["Qu'est-ce que j'emporte ?", "Quelque chose pour la météo ?"],
      tips: ["Conseils pour se déplacer", "Que devrais-je savoir avant de partir ?"],
      bookings: ["À quelle heure j'atterris ?", "Combien dure mon escale ?"],
      expenses: ["Combien ai-je dépensé ?", "Qui doit quoi à qui ?", "Suis-je dans le budget ?"],
    },
    category: {
      RESTAURANT: 'Restaurant', CAFE: 'Café', ATTRACTION: 'Attraction',
      VIEWPOINT: 'Point de vue', NEIGHBORHOOD: 'Quartier', PARK: 'Parc',
      SHOP: 'Boutique', EXPERIENCE: 'Expérience', TRANSPORT_HUB: 'Transport',
      BEACH: 'Plage', NATURE: 'Nature', PARKING: 'Parking', OTHER: 'Autre',
    },
    context: { places: 'Lieux', itinerary: 'Itinéraire', packing: 'Bagages', tips: 'Conseils', bookings: 'Réservations', expenses: 'Dépenses', general: 'Voyage' },
    packingTitle: 'Liste de bagages',
    packingItems_one: '{{count}} article',
    packingItems_other: '{{count}} articles',
    packingGoToTab: "Ouvrir l'onglet Bagages",
    budgetTitle: 'Budget proposé',
    dayPlanTitle: 'Plan de la journée',
    dayNumber: 'Jour {{number}}',
    showPhotos: 'Voir les photos',
    activitiesCount_one: '{{count}} activité',
    activitiesCount_other: '{{count}} activités',
    acceptDay: 'Accepter la journée',
    reorderTitle: 'Réorganiser',
    applyOrder: "Appliquer l'ordre",
    applying: 'Application…',
    review: {
      places: 'Voir les lieux',
      itinerary: 'Voir les activités ajoutées',
      packing: 'Voir les bagages',
      tips: 'Voir les conseils',
      expenses: 'Voir les dépenses',
    },
    tipsTitle: 'Conseils',
    tipsCount_one: '{{count}} conseil',
    tipsCount_other: '{{count}} conseils',
  },
  services: {
    title: 'Services du voyage',
    subtitle: 'Des partenaires triés sur le volet pour gérer les détails ennuyeux avant de partir. Activez avant de décoller — payez avec Gromly, gardez tout sur ce voyage.',
    partnership: 'Partenaires Gromly.',
    partnershipNote: 'Nous percevons une petite commission lorsque vous achetez via nos liens — le prix que vous payez reste identique ou inférieur grâce à notre code.',
    connectivity: {
      label: 'Connectivité',
      eSIM: 'eSIM',
      coverage: 'Couverture',
      euRoaming: 'Itinérance UE',
      heading: 'Restez connecté dès l\'atterrissage',
      body: 'Pas de changement de SIM physique. Scannez le QR avant de partir et votre téléphone capte des données dès que l\'avion touche le sol.',
      editorsPick: 'Coup de cœur',
      from: 'À partir de',
      viewPlans: 'Voir les offres',
      holafly: {
        subtitle: 'eSIMs données illimitées',
        description: 'Le favori des blogs de voyage — activation en un clic, support en français, forfaits jusqu\'à 30 jours pour les voyageurs tranquilles.',
        feature1: 'Forfaits données illimitées',
        feature2: 'Chat 24/7 en espagnol et anglais',
        feature3: '5, 10, 15 ou 30 jours',
        discountNote: '5% de réduction — utilise le code GROMLY à la caisse',
        price: '19 €',
        priceNote: 'pour 5 jours · {{destination}}', priceNoteGeneric: 'pour 5 jours',
      },
    },
  },
  notes: {
    loadError: 'Impossible de charger les notes', saveError: 'Impossible d\'enregistrer la note',
    createError: 'Impossible de créer la note', deleteConfirm: 'Supprimer cette note ?',
    deleteError: 'Impossible de supprimer la note',
    untitled: 'Sans titre', empty: 'Aucun contenu',
    new: 'Nouvelle', emptyState: 'Aucune note pour l\'instant', createFirst: 'Créer votre première note',
    selectOrCreate: 'Sélectionnez une note ou créez-en une nouvelle',
    allNotes: 'Toutes les notes', saved: 'Enregistré', delete: 'Supprimer la note',
    titleLabel: 'Titre', contentLabel: 'Contenu',
    titlePlaceholder: 'Titre de la note', contentPlaceholder: 'Écrivez vos notes ici…',
    uploadError: 'Impossible de télécharger le fichier', deleteDocError: 'Impossible de supprimer le fichier',
    attachments: 'Pièces jointes', upload: 'Télécharger',
    dropHere: 'Cliquez pour joindre des fichiers (images ou PDFs)',
  },
  album: {
    ownPhotos: { title: "Vos photos pour l’album", upload: "Importer", hint: "Seulement dans votre album : elles ne vont pas dans la Galerie et personne d’autre du voyage ne les voit.", tripPhotos: "Photos du voyage", remove: "Retirer cette photo de votre album" },
    redoDay: { button: "Refaire ce jour", confirmTitle: "Refaire ce jour depuis le journal ?", confirmBody_one: "Sa page est refaite avec les photos et le texte du jour. Ce que vous y avez modifié est perdu.", confirmBody_other: "Ses {{count}} pages sont refaites avec les photos et le texte du jour. Ce que vous y avez modifié est perdu." },
    wizard: {
      title_create: "Créez votre album", title_restart: "Recommencer l’album", steps: "Étapes", next: "Suivant",
      submit_create: "Créer l’album", submit_restart: "Recommencer", restartWarning: "Toutes les pages sont refaites depuis le journal. Les photos importées dans l’album restent.",
      format: { step: "Format", title: "Taille et forme", body: "Vous pouvez le changer à tout moment ; les pages gardent leur contenu." },
      theme: { step: "Style", title: "Le style de l’album", body: "Papier et couleurs. La typographie et les cadres photo sont dans l’éditeur." },
      density: { step: "Photos", title: "Combien de photos par jour ?", body: "Les photos choisies dans le journal entrent toujours ; ceci indique seulement combien on en ajoute.",
        FEW: "Peu", FEW_hint: "Jusqu’à 2 par jour", NORMAL: "Équilibré", NORMAL_hint: "Jusqu’à 6 par jour", ALL: "Toutes", ALL_hint: "Toutes les photos de chaque jour",
        pages_one: "{{count}} page", pages_other: "{{count}} pages", tooLong: "Plus de {{max}} pages : la fin est coupée" },
      cover: { step: "Couverture", title: "La photo de couverture", body: "Vous pourrez la changer ensuite depuis la page de couverture." },
    },
    emptyTitle: 'Ton album du voyage',
    emptyBody: 'On le commence avec ton journal et tes photos, une page par jour. Ensuite tu choisis la mise en page, les photos et les textes. Il n\'est visible que par toi.',
    create: 'Créer mon album',
    loadError: "Impossible de charger ton album", saveError: "Impossible d'enregistrer l'album",
    page: 'Page {{number}}', template: 'Mise en page', addPage: 'Ajouter une page',
    deletePageN: 'Supprimer la page {{number}}',
    deletePage: 'Supprimer la page', deletePageConfirm: "Supprimer cette page de l'album ?",
    restart: 'Recommencer depuis le journal',
    templates: { COVER: 'Couverture', STATS: 'En chiffres', ONE_PHOTO: 'Une photo', TWO_PHOTOS: 'Deux photos', THREE_PHOTOS: 'Trois photos', FOUR_PHOTOS: 'Quatre photos', TEXT_PHOTO: 'Texte et photo', TRIP_MAP: "Carte du voyage", DAY_MAP: "Carte du jour", TEXT_ONLY: 'Texte', FULL_BLEED: 'Pleine page', TWO_PHOTOS_ASYM: 'Grande et petite', THREE_STRIPS: 'Trois bandes', FIVE_PHOTOS: 'Cinq photos', SIX_PHOTOS: 'Six photos', MOSAIC: 'Mosaïque', TWO_PHOTOS_TEXT: 'Deux photos et texte', QUOTE: 'Citation', PANORAMA: 'Panoramique', PANORAMA_FRAMED: 'Panoramique avec marges', TRIP_MAP_SPREAD: 'Carte en double page', COVER_WRAP: 'Photo enveloppante', COVER_FULL: "Photo pleine page", COVER_TYPE: "Typographique", COVER_FRAMED: "Photo encadrée", COVER_MOSAIC: "Quatre photos", COVER_MAP: "Carte du voyage", COVER_WRAP_FRAMED: "Couverture encadrée", COVER_WRAP_TWO: "Couverture à deux photos" },
    spread: { cover: 'Couverture', back: 'Quatrième de couverture', front: 'Première de couverture', wrap: 'Couverture entière', pages: 'Pages {{pages}}', add: 'Ajouter deux pages', delete: 'Supprimer ces deux pages', deleteN: 'Supprimer les pages {{pages}}', deleteConfirm: "Supprimer ces deux pages de l'album ?", swap: 'Échanger gauche et droite', endpaper: "Intérieur de la couverture : rien n'y est imprimé", join: 'Les réunir', joinTitle: 'Réunir les deux pages ?', joinBody: "Cette mise en page couvre les deux pages. Ce qui ne tient pas de la page d'en face sera perdu." },
    spine: { title: 'Dos', placeholder: 'Titre sur le dos', width: "Environ {{mm}} mm de large : la largeur exacte dépend de l'imprimeur.", tooThin: 'Environ {{mm}} mm : un titre demande {{min}} mm. Ajoutez des pages pour lui faire de la place.' },
    templateGroups: { label: "Aller aux mises en page", covers: "Couvertures", '1': '1', '2': '2', '3': '3', '4+': '4+', text: 'Texte', map: 'Carte', spread: 'Double page' },
    templateSections: { 'covers': "Couvertures", '1': "Une photo", '2': "Deux photos", '3': "Trois photos", '4+': "Quatre photos ou plus", 'text': "Texte", 'map': "Cartes et chiffres", 'spread': "Double page" },
    slot: { PHOTO: 'Ajoute une photo', TITLE: 'Ajoute un titre', TEXT: 'Ajoute du texte', MAP: "Choisis le jour" },
    statsTitle: 'Le voyage en chiffres',
    choosePhoto: 'Choisis une photo', removePhoto: 'Retirer la photo', used: 'Utilisée',
    noPhotos: "Ce voyage n'a pas encore de photos. Ajoute-les dans le Journal.",
    selectHint: 'Clique sur un cadre de la page pour le remplir, ou glisse une photo dessus.',
    chars: '{{count}} / {{max}}', tooLong: 'Trop long pour ce cadre : raccourcis-le ou choisis une mise en page avec plus de place.',
    fromDiary: 'Insérer depuis le journal', entryOption: 'Jour {{number}} · {{text}}',
    dayN: "Jour {{n}}", chooseDay: "Choisis le jour",
    tripMapHint: "La carte du voyage se dessine seule à partir de ton itinéraire : chaque jour, dans sa couleur.",
    figures: { legend: "Légende", map: "Carte", world: "Monde", country: "Pays", show: "Afficher", route: "Itinéraire", stops: "Points seuls", outline: "Contour", outlineShow: "Afficher", outlineHide: "Masquer", kmCaption: "Kilomètres sur la route" },
    preview: { open: "Feuilleter", title: "Aperçu de l'album", prev: "Page précédente", next: "Page suivante" },
    style: { typeface: "Typographie", font: "Police", fontOfAlbum: "Celle de l'album", sizeDown: "Plus petite", sizeUp: "Plus grande", photoFrame: "Cadre des photos", textSize: "Taille du texte", textAlign: "Alignement", size_S: "Petit", size_M: "Moyen", size_L: "Grand", align_left: "Gauche", align_center: "Centre", align_right: "Droite", theme: "Thème de l'album", pageBackground: "Fond de cette page", fromTheme: "Thème", veil: "Voile", veil_dark: "Voile sombre", veil_light: "Voile clair", removePhoto: "Retirer la photo", photoBackground: "Mettre une photo en fond" },
    themes: { paper: "Papier", minimal: "Minimal", night: "Nuit", sand: "Sable", sage: "Sauge", kraft: "Kraft" },
    backgrounds: { paper: "Papier", white: "Blanc", sand: "Sable", sage: "Sauge", sky: "Ciel", blush: "Rose", kraft: "Kraft", night: "Nuit", forest: "Forêt", ink: "Encre", "paper-dots": "Papier à pois", "paper-grid": "Papier quadrillé", "white-notebook": "Carnet", "sand-stripes": "Sable rayé", "sage-dots": "Sauge à pois", "night-dots": "Nuit étoilée" },
    format: { title: "Taille et orientation", "a4-portrait": "A4 portrait", "a5-portrait": "A5 portrait", "a4-landscape": "A4 paysage", "a5-landscape": "A5 paysage", "square-30": "Carré 30", "square-20": "Carré 20" },
    fontPairs: { classic: "Classique", modern: "Moderne", handwritten: "Manuscrite", typewriter: "Machine à écrire", elegant: "Élégante", editorial: "Éditoriale", rounded: "Arrondie", poster: "Affiche", script: "Calligraphie", retro: "Rétro" },
    photoFrames: { none: "Sans cadre", "white-border": "Bord blanc", rounded: "Arrondi", shadow: "Ombre" },
    tabs: { page: "Page", album: "Album" },
  },
  journal: {
    views: { list: 'Liste', map: 'Carte' },
    map: { empty: 'Pas encore de photos sur la carte', emptyBody: 'Une photo apparaît ici dès qu’elle est liée à une étape avec un lieu.', unavailable: 'La carte n’est pas disponible pour le moment.', unplaced_one: '{{count}} photo sans lieu', unplaced_other: '{{count}} photos sans lieu' },
    title: 'Journal',
    empty: { title: 'Rien d’écrit pour l’instant', body: 'Choisissez un jour et racontez ce que vous avez fait, avec vos photos.' },
    write: 'Écrire',
    placeholder: 'Qu’avez-vous fait aujourd’hui ? De quoi voudrez-vous vous souvenir ?',
    choosePhotos_one: '{{count}} photo choisie',
    choosePhotos_other: '{{count}} photos choisies',
    addPhotos: 'Ajouter des photos',
    noPhotosToChoose: 'Pas encore de photos ce jour-là. Ajoutez-en d’ici.',
    sharedLabel: 'Les abonnés du lien la verront',
    sharedHint: 'Décochez pour garder cette entrée pour le groupe.',
    groupOnly: 'Groupe seulement',
    groupOnlyHint: 'Les abonnés du lien ne voient pas cette entrée',
    deleteConfirm: 'Supprimer cette entrée du journal ? Ses photos restent dans le voyage.',
    loadError: 'Impossible de charger le journal',
    saveError: 'Impossible d’enregistrer l’entrée',
    deleteError: 'Impossible de supprimer l’entrée',
    previousPhoto: 'Photo précédente',
    nextPhoto: 'Photo suivante',
  },
  stats: {
    title: 'Vos voyages',
    km: 'km',
    days_one: 'jour', days_other: 'jours',
    stops_one: 'étape', stops_other: 'étapes',
    photos_one: 'photo', photos_other: 'photos',
    entries_one: 'entrée', entries_other: 'entrées',
    trips_one: 'voyage', trips_other: 'voyages',
    nights_one: 'nuit', nights_other: 'nuits',
    countries_one: 'pays', countries_other: 'pays',
    regions_one: 'continent', regions_other: 'continents',
    mapLabel_one: 'Carte avec {{count}} pays visité', mapLabel_other: 'Carte avec {{count}} pays visités',
  },
  gallery: {
    noStop: 'Sans étape', stopLabel: 'Étape',
    title: 'Galerie', upload: 'Ajouter des photos', uploading: 'Envoi en cours…',
    empty: {
      title: 'Aucune photo pour l’instant', dayTitle: 'Aucune photo pour ce jour pour l’instant',
      subtitle: 'Glissez-les ici ou importez-les depuis votre appareil.',
    },
    allDays: 'Toutes',
    dayOption: 'Jour {{number}}', unassignedDay: 'Sans jour', uploadedBy: 'Par {{name}}',
    download: 'Télécharger l’original', delete: 'Supprimer la photo',
    deleteConfirm: 'Supprimer cette photo ? Action irréversible.',
    loadError: 'Impossible de charger les photos', uploadError: 'Impossible d’envoyer {{name}}',
    deleteError: 'Impossible de supprimer la photo', moveError: 'Impossible de déplacer la photo',
    selection: { moveToDay: "Déplacer vers un jour", searchStop: "Chercher une étape", noStopMatch: "Aucune étape ne correspond", count_one: "{{count}} sélectionnée", count_other: "{{count}} sélectionnées", all: "Tout sélectionner", none: "Tout désélectionner", selectPhoto: "Sélectionner la photo", unselectPhoto: "Désélectionner la photo", place: "Attribuer un lieu", stopHint: "Les photos d'un autre jour passent au jour du lieu choisi.", deleteConfirm_one: "Supprimer cette photo ? Action irréversible.", deleteConfirm_other: "Supprimer {{count}} photos ? Action irréversible.", updated_one: "{{count}} photo mise à jour", updated_other: "{{count}} photos mises à jour", updateFailed: "{{count}} photos sur {{total}} n'ont pas pu être modifiées", deleted_one: "{{count}} photo supprimée", deleted_other: "{{count}} photos supprimées", deleteFailed: "{{count}} photos sur {{total}} n'ont pas pu être supprimées" },
    // ADR-0058
    suggest: { button: "Suggérer des lieux", hint: "L'IA regarde les photos et suggère l'étape du voyage où chacune a été prise. 1 crédit IA pour 10 photos.", title: "Lieux suggérés par l'IA", looking: "Analyse de {{count}} photos…", summary: "Étape trouvée pour {{found}} photos sur {{total}}. Cochez celles qui sont justes.", none: "Aucune suggestion", unsure: "Pas sûre", alreadyThere: "déjà là", apply: "Appliquer ({{count}})", privacy: "Les photos sont envoyées à OpenAI pour être analysées.", failed: "Impossible de suggérer des lieux. Réessayez." },
    placedByDate_one: '{{count}} photo placée à son jour selon sa date de prise de vue', placedByDate_other: '{{count}} photos placées à leur jour selon leur date de prise de vue',
  },
  billing: {
    credits: { label: 'Crédits de voyage' },
    paywall: {
      title: "Passez à PRO",
      description: "Vous avez utilisé vos voyages gratuits. PRO est un abonnement annuel avec des voyages illimités et jusqu'à 500 requêtes IA par mois.",
      perks: ["Voyages illimités", "500 requêtes IA par mois", "Tout ce que vous utilisez déjà, sans limites"],
      cta: "Passer à PRO",
      error: "Impossible de démarrer le paiement. Veuillez réessayer.",
    },
    aiPaywall: {
      title: "Plus de requêtes IA",
      description: "Vous avez utilisé vos requêtes IA gratuites. PRO en inclut 500 par mois.",
      cta: "Passer à PRO",
      error: "Impossible de démarrer le paiement. Veuillez réessayer.",
    },
    payment: {
      success: "Bienvenue dans PRO ! L'affichage peut prendre quelques secondes.",
      cancelled: "Paiement annulé.",
    },
  },
  landing: {
    nav: {
      features: 'Fonctionnalités',
      ai: 'IA',
      community: 'Communauté',
      marketplace: 'Marketplace',
      signIn: 'Se connecter',
      getStarted: 'Commencer',
    },
    hero: {
      eyebrow: 'Là où chaque voyage commence',
      headline1: 'Planifiez chaque',
      headline2: 'aventure.',
      subheading: "Itinéraires, dépenses, réservations et lieux à visiter — le tout dans un endroit calme, partagé uniquement avec ceux qui partent.",
      pills: {
        itinerary: 'Itinéraire',
        expenses: 'Dépenses',
        aiRoutes: 'Routes IA',
        plane: 'Vol',
        bookings: 'Réservations',
        collaborative: 'Collaboratif',
      },
      ctaPrimary: 'Commencer gratuitement',
      ctaSecondary: 'Se connecter',
    },
    mock: {
      nightsLabel: '{{range}} · {{count}} NUITS',
      tripTitle: 'Été en Islande',
      active: 'ACTIF',
      moreCount: '+{{count}} autres',
      totalSpent: 'DÉPENSÉ',
      ofBudget: 'sur {{amount}} de budget',
      activities: 'ACTIVITÉS',
      acrossDays: 'sur {{count}} jours',
      dayHeader: 'JOUR {{day}} — {{place}}',
      routeOptimized: 'Route optimisée',
      splitSettled: 'Partage réglé · {{count}}p',
      aiOptimized: 'IA Optimisé · Jour {{day}}',
      whoOwesWhom: 'QUI DOIT À QUI',
      settle: 'Régler',
      settledCount: 'RÉGLÉS · {{count}}',
    },
    ticker: {
      label: 'Voyages planifiés à',
    },
    features: {
      eyebrow: 'Tout ce dont vous avez besoin',
      headlineLine1: 'Un seul endroit pour chaque partie',
      headlineLine2Pre: 'du',
      headlineLine2Highlight: 'voyage.',
      description: "Conçu pour les vrais voyages, pas les idéalisés. Gardez le contrôle du vol jusqu'à la réservation du dîner.",
      cards: {
        itinerary: {
          title: 'Itinéraire jour par jour',
          desc: "Créez un itinéraire glisser-déposer avec activités, créneaux horaires et catégories. Partagez-le en direct avec tout le groupe.",
        },
        expenses: {
          title: 'Dépenses et partages',
          desc: "Enregistrez chaque dépense, partagez les coûts entre le groupe et voyez exactement qui doit quoi à qui en un clic.",
        },
        ai: {
          title: 'Optimiseur de routes IA',
          desc: "Indiquez vos préférences à l'IA et elle réordonne vos arrêts pour minimiser le temps de trajet. Accepte le langage naturel.",
        },
        bookings: {
          title: 'Centre de réservations',
          desc: "Gérez vols, hôtels, transports et événements au même endroit. Joignez PDF, numéros de référence et rappels.",
        },
        map: {
          title: 'Carte et lieux',
          desc: "Découvrez des endroits, marquez-les comme visités et ajoutez-les à votre itinéraire directement depuis la carte.",
        },
        collaborative: {
          title: 'Planification collaborative',
          desc: "Invitez votre équipe, attribuez des rôles et planifiez ensemble. Chacun voit les changements en temps réel, sans tableurs.",
        },
      },
    },
    ai: {
      eyebrow: 'Propulsé par IA',
      headline1: 'Votre optimiseur',
      headline2: 'de voyage personnel.',
      description: "Indiquez vos préférences à l'IA en langage naturel — horaires de repas, lieux incontournables, façon dont vous aimez voyager — et elle reconstruit votre journée en quelques secondes.",
      chips: {
        route: 'Optimisation de route',
        hints: 'Langage naturel',
        mode: 'Mode de transport',
        grouping: 'Regroupement par zone',
      },
      cta: 'Essayer gratuitement',
    },
    groups: {
      eyebrow: 'Conçu pour les groupes',
      headline1: 'Planifiez ensemble,',
      headline2: 'pas séparément.',
      description: "Invitez votre équipe, attribuez éditeurs ou spectateurs, et partagez chaque dépense automatiquement. Un clic pour régler — sans messages WhatsApp gênants.",
      features: {
        invite: 'Inviter par lien, gérer les rôles',
        split: 'Calcul automatique des partages',
        settle: 'Règlement des dettes en un clic',
        sync: 'Synchronisation en temps réel',
      },
      morePlanning: 'planifient ensemble',
      morePrefix: '+{{count}} autres',
    },
    marketplace: {
      eyebrow: 'Marketplace de la communauté',
      headline1: 'Découvrez des voyages',
      headline2: 'de la communauté.',
      description: "Parcourez des itinéraires publics de voyageurs du monde entier. Clonez n'importe quel voyage en un clic et adaptez-le à vos dates, votre équipe et votre budget — sans repartir de zéro.",
      features: {
        browse: 'Parcourir des itinéraires publics sélectionnés',
        clone: "Cloner et personnaliser n'importe quel voyage",
        ratings: 'Notes et avis de la communauté',
        follow: 'Suivre les voyageurs que vous admirez',
      },
      cta: 'Explorer la communauté',
      cloneTrip: 'Cloner le voyage',
      nights: '{{country}} · {{count}} nuits',
      tripTags: {
        nature: 'Nature',
        culture: 'Culture',
        adventure: 'Aventure',
        hiking: 'Randonnée',
        beach: 'Plage',
        food: 'Gastronomie',
        souks: 'Souks',
      },
    },
    bottomCta: {
      eyebrow: 'Commencer gratuitement',
      headline1: 'Votre prochaine aventure',
      headline2: 'commence ici.',
      description: 'Rejoignez des milliers de voyageurs qui planifient mieux, partagent plus juste et gardent de meilleurs souvenirs.',
      button: 'Créer un compte gratuit',
      haveAccount: "J'ai déjà un compte",
      fineprint: 'Aucune carte requise · Plan gratuit disponible pour toujours',
    },
    footer: {
      privacy: 'Confidentialité',
      terms: 'Conditions',
      legal: 'Mentions légales',
      copyright: '© MMXXVI GROMLY · VESTIGI PLATFORM, S.L.',
    },
  },
  explore: {
    toast: {
      loadFailed: 'Impossible de charger les voyages',
      tripNotFound: 'Voyage introuvable',
      ratingFailed: "Échec de la notation",
      followFailed: 'Impossible de mettre à jour le suivi',
      cloned: 'Voyage ajouté à votre compte !',
      cloneFailed: 'Échec du clonage',
      insufficientCredits: "Plus aucun crédit de voyage. Mettez à niveau pour en obtenir plus.",
    },
    breadcrumb: 'Communauté · Modèles',
    heading: 'Explorer les voyages',
    searchPlaceholder: 'Destination ou voyage…',
    feed: { all: 'Tous', following: 'Suivis' },
    filters: {
      days: 'Jours', any: 'Tous', clear: 'Effacer',
      button: 'Filtres',
      title: 'Filtres',
      sortBy: 'Trier par',
      destination: 'Destination',
      destinationPlaceholder: 'ex. Paris, Italie…',
      nights: 'Nuits',
      budgetPerDay: 'Budget par jour',
      budgetHint: 'Calculé à partir des dépenses réelles divisées par la durée du voyage.',
      activities: 'Types d\'activités',
      month: 'Mois du voyage',
      anyMonth: 'Tous les mois',
      participants: 'Taille du groupe',
      min: 'Min',
      max: 'Max',
      apply: 'Appliquer',
      reset: 'Réinitialiser',
      clearAll: 'Tout effacer',
      activityType: {
        RESTAURANT: 'Restaurant',
        CAFE: 'Café',
        MONUMENT: 'Monument',
        VIEWPOINT: 'Point de vue',
        NEIGHBORHOOD: 'Quartier',
        PARK: 'Parc',
        SHOP: 'Boutique',
        EXPERIENCE: 'Expérience',
        TRANSPORT: 'Transport',
        PARKING: 'Parking',
        BEACH: 'Plage',
        NATURE: 'Nature',
        ACCOMMODATION: 'Hébergement',
        OTHER: 'Autre',
      },
    },
    sort: { recent: 'Plus récents', topRated: 'Mieux notés', mostUsed: 'Plus utilisés' },
    results: {
      trips_one: '{{count}} voyage',
      trips_other: '{{count}} voyages',
      days_one: '{{count}} jour',
      days_other: '{{count}} jours',
    },
    empty: {
      title: 'Aucun voyage trouvé',
      body: 'Essayez une autre recherche ou un autre filtre.',
    },
    loadMore: 'Charger plus',
    detail: {
      backToExplore: 'Explorer',
      mapUnavailable: 'Carte indisponible',
      allPlaces: 'Tous les lieux',
      dayByDay: 'Jour par jour',
      dayLabel: 'Jour {{n}}',
      stops_one: '{{count}} arrêt',
      stops_other: '{{count}} arrêts',
      calculatingRoute: "Calcul de l'itinéraire…",
      noStopsToday: 'Aucun arrêt avec localisation ce jour-là.',
      stopFallback: 'Arrêt {{n}}',
      openInMaps: 'Ouvrir dans la carte',
      noItinerary: 'Aucun itinéraire planifié.',
      activities_one: '{{count}} activité',
      activities_other: '{{count}} activités',
      noActivities: 'Aucune activité planifiée',
      noPlaces: 'Aucun lieu listé.',
      noTips: 'Aucun conseil partagé.',
      actualSpend: 'Dépense réelle',
      tripNotes: 'Notes du voyage',
      useAsTemplate: 'Utiliser comme modèle',
      used: 'Utilisé',
      times_one: '{{count}} fois',
      times_other: '{{count}} fois',
      communityRating: 'Note de la communauté',
      noRatingsYet: 'Pas encore de notes',
      ratings_one: '{{count}} note',
      ratings_other: '{{count}} notes',
      rateThisTrip: 'Notez ce voyage',
      youRated_one: 'Vous avez noté {{count}} étoile',
      youRated_other: 'Vous avez noté {{count}} étoiles',
      tripDetails: 'Détails du voyage',
      stats: {
        destination: 'Destination',
        dates: 'Dates',
        duration: 'Durée',
        people: 'Personnes',
        activities: 'Activités',
        nights_one: '{{count}} nuit',
        nights_other: '{{count}} nuits',
      },
      author: 'Auteur',
      publishedAgo: 'Publié il y a {{time}}',
      follow: 'Suivre',
      following: 'Suivi',
      travelMode: {
        WALKING: 'Marche',
        DRIVING: 'Voiture',
        BICYCLING: 'Vélo',
        TRANSIT: 'Transport',
      },
      tabs: {
        itinerary: 'Itinéraire',
        places: 'Lieux',
        map: 'Carte',
        tips: 'Conseils & Infos',
        expenses: 'Budget',
        notes: 'Notes',
      },
    },
    clone: {
      title: 'Utiliser comme modèle',
      tripName: 'Nom du voyage',
      whenLabel: 'Quand voulez-vous partir ?',
      tripEnds: 'Se termine',
      keepOriginalDates: "Laissez vide pour conserver les dates d'origine.",
      addToMyTrips: 'Ajouter à mes voyages',
      daysLabel: 'Jours à copier',
      selectAll: 'Tous',
      clearAll: 'Aucun',
      selectAtLeastOne: 'Sélectionnez au moins un jour',
      untitledDay: 'Jour sans titre',
      activitiesCount_one: '{{count}} activité',
      activitiesCount_other: '{{count}} activités',
      summaryDays_one: '{{count}} jour',
      summaryDays_other: '{{count}} jours',
      summaryNights_one: '{{count}} nuit',
      summaryNights_other: '{{count}} nuits',
    },
  },
  pdf: {
    nights_one: '{{count}} nuit', nights_other: '{{count}} nuits',
    coverLabel: 'Itinéraire de voyage', travellers: 'Voyageurs', budget: 'Budget', notes: 'Notes',
    generatedOn: 'Généré le {{date}}',
    itinerary: 'Itinéraire', placesToVisit: 'Lieux à visiter', bookings: 'Réservations',
    expenses: 'Dépenses', checklists: 'Checklists', tips: 'Conseils',
    meals: 'Repas', grocery: 'Liste de courses',
    flights: 'Vols', hotels: 'Hôtels', otherReservations: 'Autres réservations',
    balances: 'Soldes',
    category: 'Catégorie', name: 'Nom', zone: 'Zone', address: 'Adresse', visited: 'Visité',
    direction: 'Sens', route: 'Trajet', departure: 'Départ', arrival: 'Arrivée',
    flight: 'Vol', ref: 'Réf', outbound: 'Aller', return: 'Retour',
    type: 'Type', title: 'Titre', date: 'Date', description: 'Description',
    paidBy: 'Payé par', amount: 'Montant', owes: 'Doit',
    totalSpent: 'Total dépensé', perPerson: 'Par personne', checkIn: 'Arrivée', checkOut: 'Départ',
  },
  essentials: {
    heading: "Essentiels pour {{country}}",
    currency: "Monnaie", language: "Langue", capital: "Capitale", callingCode: "Indicatif",
    plug: "Électricité", plugType: "Type", driving: "Conduite", tapWater: "Eau du robinet", emergency: "Urgences",
    emergencyGeneral: "général", emergencyPolice: "police", emergencyAmbulance: "ambulance", emergencyFire: "pompiers",
    drive: { left: "À gauche", right: "À droite" },
    water: { safe: "Potable", caution: "Avec prudence", unsafe: "Buvez en bouteille" },
    advisory: { normal: "Pas d'alerte majeure", see_advisory: "Consultez les conseils aux voyageurs", avoid_essential: "Évitez tout voyage non essentiel", avoid_all: "Évitez tout voyage" },
    practicalDisclaimer: "Information indicative — peut varier localement.",
    visa: {
      visa_free: "Sans visa", visa_on_arrival: "Visa à l'arrivée", e_visa: "e-Visa", eta: "Autorisation de voyage", visa_required: "Visa requis", no_admission: "Entrée refusée",
      upToDays_one: "jusqu'à {{count}} jour", upToDays_other: "jusqu'à {{count}} jours",
    },
    requirements: {
      heading: "Conditions d'entrée", forNationality: "Pour un passeport {{nationality}}",
      forCountry: "Pour entrer en {{country}}",
      visa: "Visa", passport: "Passeport", vaccines: "Vaccins", unknown: "Non disponible",
      passportValidity_one: "Valable {{count}}+ mois après le séjour", passportValidity_other: "Valable {{count}}+ mois après le séjour", passportValidZero: "Aucune validité supplémentaire requise",
      noVaccines: "Aucun vaccin exigé à l'entrée", mandatory: "Obligatoire",
      checkedOn: "Vérifié le {{date}}", verifyOfficial: "Vérifier officiellement",
      missingPrompt: "Ajoutez votre nationalité pour voir les conditions de visa et vaccins", empty: "Aucune condition d'entrée à afficher",
      disclaimer: "Information indicative, non officielle. Les règles d'entrée et sanitaires évoluent : confirmez toujours auprès du consulat de la destination ou d'une source officielle avant de partir.",
    },
  },
  redeemCode: {
    entry: "J'ai un code",
    title: "Ouvrez votre voyage",
    body: "Votre agence de voyages vous a donné un code de 8 caractères. Il fonctionne avec l'e-mail que vous lui avez donné : {{email}}.",
    label: "Code du voyage",
    submit: "Ouvrir mon voyage",
    joined: "Votre voyage est prêt",
    errors: {
      notFound: "Ce code ne correspond à aucune invitation pour {{email}}. Vérifiez-le, et que vous êtes connecté avec l'e-mail donné à votre agence.",
      emailNotVerified: "Vérifiez d'abord votre e-mail : nous vous avons envoyé un lien à l'inscription.",
      expired: "Ce code a expiré. Demandez-en un nouveau à votre agence.",
      revoked: "Votre agence a annulé ce code. Demandez-lui-en un nouveau.",
      tooMany: "Trop de tentatives. Réessayez dans une heure.",
      generic: "Nous n'avons pas pu ouvrir le voyage. Réessayez.",
    },
  },
  agency: {
    card: {
      preparedBy: "Préparé par",
      emergency: "Téléphone d'urgence",
      email: "E-mail",
    },
    managesTravellers: "Sur ce voyage, c'est votre agence qui gère les voyageurs. Demandez-lui d'ajouter quelqu'un.",
    panel: {
      tabs: {
        current: "Voyages",
        past: "Passés",
        templates: "Circuits",
        clients: "Clients",
        team: "Équipe",
        settings: "Réglages",
      },
      currentTab: "En cours",
      newTrip: "Nouveau voyage",
      newTemplate: "Nouveau circuit",
      newDeparture: "Nouveau départ",
      duplicate: "Dupliquer",
      duplicateName: "{{name}} (copie)",
      duplicateFailed: "Impossible de dupliquer le circuit",
      days_one: "{{count}} jour",
      days_other: "{{count}} jours",
      nights_one: "{{count}} nuit",
      nights_other: "{{count}} nuits",
      addDescription: "Ajouter une description",
      descriptionPlaceholder: "Décrivez le circuit : ce qu’il comprend, pour qui…",
      descriptionFailed: "Impossible d’enregistrer la description",
      empty: {
        currentTitle: "Aucun voyage en cours",
        currentBody: "Créez un voyage, ou un départ à partir d'un de vos circuits.",
        pastTitle: "Pas encore de voyages passés",
        pastBody: "Les voyages arrivent ici une semaine après leur fin. Ils appartiennent alors à vos clients.",
        templatesTitle: "Pas encore de circuits",
        templatesBody: "Un circuit est un voyage que vous vendez encore et encore. Préparez-le une fois et créez un départ pour chaque date.",
      },
      managedUntil: "Géré par vous jusqu'au {{date}}",
      handedOver: "À votre client depuis le {{date}}",
      open: "Ouvrir",
      lead: "Voyageur principal",
      status: {
        NOT_INVITED: "Pas invité",
        INVITED: "Invité",
        ACTIVATED: "Activé",
        JOINED: "Inscrit",
      },
      copyCode: "Copier le code",
      codeCopied: "Code copié",
      activations: {
        title: "Voyageurs activés",
        count_one: "{{count}} voyageur activé",
        count_other: "{{count}} voyageurs activés",
        empty: "Personne ne s'est activé ce mois-ci.",
        month: "Mois",
      },
      usage: {
        title: "Ce mois-ci",
        maps: "Maps : {{used}} sur {{cap}}",
        ai: "IA : {{used}} sur {{cap}} requêtes",
      },
      loadFailed: "Impossible de charger l'agence",
    },
    home: {
      tagline: "Ce qui vous attend aujourd'hui.",
      stats: {
        ongoing: "En cours",
        leavingSoon: "Départs dans les 7 jours",
        pending: "Voyageurs non activés",
        activated: "Activés ce mois-ci",
      },
      sections: {
        attention: "À traiter",
        ongoing: "En cours",
        upcoming: "Prochains départs",
        activations: "Dernières activations",
        circuits: "Circuits",
      },
      attentionHint: "Ils n'ont pas encore utilisé leur code, et le voyage est en cours ou part dans moins de deux semaines.",
      allClear: "Tout le monde est là. Rien ne requiert votre attention.",
      leavesToday: "Part aujourd'hui",
      leavesTomorrow: "Part demain",
      leavesIn_one: "Part dans {{count}} jour",
      leavesIn_other: "Part dans {{count}} jours",
      dayOf: "Jour {{day}} sur {{total}}",
      activatedOf: "{{done}}/{{total}} activés",
      noUpcoming: "Aucun départ programmé.",
      noActivations: "Personne ne s'est encore activé ce mois-ci.",
      allTrips: "Tous les voyages",
      seeAll: "Tout voir",
      emptyTitle: "Votre agence est prête",
      emptyBody: "Créez votre premier voyage, ou un circuit que vous vendrez encore et encore.",
    },
    departure: {
      title: "Nouveau départ : {{name}}",
      name: "Nom du voyage",
      startDate: "Date de début",
      travellers: "Voyageurs",
      leadHint: "Le premier devient propriétaire du voyage en utilisant son code.",
      travellerName: "Nom",
      travellerEmail: "E-mail (pour envoyer le code)",
      addTraveller: "Ajouter un voyageur",
      removeTraveller: "Retirer",
      submit: "Créer le départ",
      created: "Départ créé",
      invitesFailed_one: "{{count}} invitation n'a pas pu être envoyée",
      invitesFailed_other: "{{count}} invitations n'ont pas pu être envoyées",
      failed: "Impossible de créer le départ",
    },
    settings: {
      brandTitle: "Ce que voient vos voyageurs",
      brandHint: "Affiché dans le voyage tant que vous le gérez.",
      name: "Nom de l'agence",
      emergencyPhone: "Téléphone d'urgence",
      contactEmail: "E-mail de contact",
      logo: "Logo",
      uploadLogo: "Importer un logo",
      removeLogo: "Retirer le logo",
      save: "Enregistrer",
      saved: "Enregistré",
      saveFailed: "Impossible d'enregistrer",
    },
    clients: {
      title: "Clients",
      new: "Nouveau client",
      edit: "Modifier le client",
      search: "Rechercher par nom ou e-mail",
      saveFailed: "Impossible d'enregistrer le client",
      loadFailed: "Impossible de charger le client",
      deleteFailed: "Impossible de supprimer le client",
      form: {
        name: "Nom",
        email: "E-mail",
        phone: "Téléphone",
        birthDate: "Date de naissance",
        notes: "Notes",
        emailInvalid: "Cet e-mail semble incorrect",
        emailHint: "Sans e-mail, il voyage quand même mais ne reçoit pas de code : quelqu'un du groupe peut lui partager le voyage.",
      },
      picker: {
        noEmail: "Sans e-mail — pas de code",
        makeLead: "Faire voyageur principal",
        remove: "Retirer",
        search: "Rechercher dans vos clients",
        noMatch: "Aucun client ne correspond.",
        emptyBook: "Votre fichier clients est vide : ajoutez le premier.",
        createNamed: "Nouveau client « {{name}} »",
      },
      bornOn: "Né le {{date}}",
      hasAccount: "A un compte",
      trips: "Voyages avec vous",
      noTrips: "Aucun voyage pour l'instant.",
      deleteTitle: "Supprimer {{name}} ?",
      deleteBody: "Il quitte votre fichier clients. Ses voyages restent les siens.",
      noMatchTitle: "Aucun client ne correspond",
      emptyTitle: "Pas encore de clients",
      emptyBody: "Chaque voyageur ajouté à un voyage arrive ici : la prochaine fois, il suffira de le choisir.",
      noContact: "Aucune coordonnée",
      tripCount_one: "{{count}} voyage",
      tripCount_other: "{{count}} voyages",
    },
    team: {
      loadFailed: "Impossible de charger l'équipe",
      lastAdmin: "L'agence a besoin d'au moins un admin.",
      failed: "Une erreur s'est produite",
      invited: "Invitation envoyée à {{email}}",
      alreadyMember: "Déjà dans l'équipe.",
      inviteTitle: "Inviter dans l'équipe",
      inviteHint: "Il recevra un e-mail et rejoindra l'équipe en acceptant avec cette adresse. Ses voyages personnels restent les siens.",
      emailPlaceholder: "collegue@agence.com",
      role: "Rôle",
      roles: {
        ADMIN: "Admin",
        AGENT: "Agent",
      },
      invite: "Inviter",
      you: "(vous)",
      remove: "Retirer {{name}}",
      pending: "En attente",
      revoke: "Annuler l'invitation",
      removeTitle: "Retirer {{name}} de l'équipe ?",
      removeBody: "Il perd l'accès aux voyages et aux clients de l'agence. Ses voyages personnels restent les siens.",
      removeConfirm: "Retirer",
    },
    invite: {
      gone: {
        expired: "Cette invitation a expiré",
        used: "Cette invitation a déjà été utilisée",
        notFound: "Cette invitation n'existe pas",
      },
      goneBody: "Demandez à l'agence de vous en envoyer une nouvelle.",
      goHome: "Aller à l'accueil",
      accepted: "Bienvenue chez {{agency}}",
      verifyFirst: "Vérifiez d'abord votre e-mail, puis acceptez.",
      failed: "Impossible d'accepter l'invitation",
      eyebrow: "Invitation",
      title: "Rejoignez {{agency}}",
      body: {
        ADMIN: "En tant qu'admin : vous préparez les voyages de ses clients et gérez l'équipe.",
        AGENT: "Vous préparerez les voyages de ses clients.",
      },
      keepTrips: "Vos voyages personnels restent les vôtres : passez de l'un à l'autre depuis le menu de votre profil.",
      accept: "Accepter et rejoindre",
      wrongEmail: "Cette invitation est pour {{invited}} et vous êtes connecté en tant que {{current}}. Connectez-vous avec cet e-mail pour l'accepter.",
    },
    wizard: {
      ask: "Pour qui est ce voyage ?",
      hint: "Choisissez-les parmi vos clients, ou ajoutez-en un nouveau. Le premier est le voyageur principal : le voyage est à lui dès qu'il utilise son code.",
      clientsCount_one: "{{count}} client",
      clientsCount_other: "{{count}} clients",
    },
  },
  admin: {
    loadFailed: "Impossible de charger. Réessayez.",
    acting: { inside: "Vous êtes dans {{agency}} en tant que Gromly", leave: "Quitter", enter: "Entrer" },
    usage: {
      subtitle: "Du {{from}} au {{to}}, comparé au {{prevFrom}} – {{prevTo}}.", subtitleLoading: "Chargement…",
      rangeLabel: "Période", from: "Du", to: "Au",
      range: { month: "Ce mois-ci", lastMonth: "Mois dernier", "7d": "7 jours", "30d": "30 jours", "90d": "90 jours", "12m": "12 mois", custom: "Personnalisé" },
      segmentLabel: "À qui revient la dépense", segment: { all: "Tout", personal: "Voyages personnels", agency: "Voyages d'agence" },
      clearFilter: "Ne plus filtrer par {{name}}", deletedUser: "Compte supprimé", deletedTrip: "Voyage supprimé",
      vsPrevious: "Par rapport à la période précédente",
      tiles: { total: "Total", maps: "Maps", ai: "IA", users: "Utilisateurs avec dépense", outside: "Hors voyages", projection: "Projection du mois" },
      calls_one: "{{count}} appel", calls_other: "{{count}} appels",
      aiDetail: "{{calls}} appels · {{credits}} crédits", perUser: "{{amount}} par utilisateur",
      outsideDetail: "Recherche et assistant, avant que le voyage existe", projectionDetail: "Au rythme de ce mois",
      trend: "Dépense sur la période", trendLabel: "Dépense Maps et IA sur la période",
      byMaps: "Maps par service", byAi: "IA par fonction", byModel: "IA par modèle",
      topUsers: "Qui dépense le plus", topTrips: "Voyages les plus coûteux", noAgencySpend: "Aucune dépense d'agence sur cette période",
      split: "Maps {{maps}} · IA {{ai}}", mapsCap: "Plafond Maps {{amount}}/mois",
      empty: "Aucune dépense sur cette période",
      footnote: "Enregistré depuis le 27 juillet 2026. La dépense dans un voyage d'agence compte pour l'agence (ADR-0034) ; celle hors voyage, comme personnelle.",
      maps: { placeResolution: "Trouver des lieux", placeDetails: "Fiches de lieux", photos: "Photos", search: "Recherche et saisie auto", routes: "Itinéraires", mapLoads: "Chargements de carte", other: "Autres" },
      ai: { chatQuestion: "Chat · questions", chatAction: "Chat · actions", chatTriage: "Chat · tri", chat: "Chat · autres", import: "Import de documents", extraction: "Lecture de billets et tickets", wizard: "Assistant de nouveau voyage", essentials: "Infos pays" },
    },
    nav: { overview: "Aperçu", users: "Utilisateurs", agencies: "Agences", usage: "Usage et coûts" },
    overview: {
      title: "Gromly en un coup d'œil", subtitle: "Qui l'utilise, d'où ils viennent et ce que ça coûte.",
      signups: "Inscriptions par mois", trips: "Voyages créés par mois", seeUsers: "Voir les utilisateurs",
      personalTrips: "Personnels", agencyTrips: "Avec une agence", manageAgencies: "Gérer les agences",
      footnote: "Les utilisateurs actifs sont comptés depuis le début de l'enregistrement de l'activité. Les voyages de démo et les modèles d'agence ne comptent pas comme voyages.",
      chartLabel: "Graphique mensuel : {{series}}",
      activations_one: "{{count}} voyageur activé ce mois-ci", activations_other: "{{count}} voyageurs activés ce mois-ci",
      maps: "Maps ce mois-ci", ai: "Requêtes IA",
      stats: {
        users: "Utilisateurs", usersDetail_one: "{{count}} nouveau ce mois-ci", usersDetail_other: "{{count}} nouveaux ce mois-ci",
        active: "Actifs (30 jours)", activeDetail_one: "{{count}} ces 7 derniers jours", activeDetail_other: "{{count}} ces 7 derniers jours",
        pro: "PRO", proDetail_one: "{{count}} offert", proDetail_other: "{{count}} offerts",
        fromAgencies: "Venus par des agences", fromAgenciesDetail_one: "{{count}} a ensuite créé son propre voyage", fromAgenciesDetail_other: "{{count}} ont ensuite créé leur propre voyage",
        trips: "Voyages", tripsDetail_one: "{{count}} ce mois-ci · {{agency}} avec agence", tripsDetail_other: "{{count}} ce mois-ci · {{agency}} avec agence",
        cost: "Coût du mois", costDetail: "Mois dernier : {{amount}}",
      },
    },
    users: {
      total_one: "{{count}} utilisateur", total_other: "{{count}} utilisateurs",
      search: "Rechercher par nom, identifiant ou e-mail", originLabel: "Origine", anyOrigin: "Toute origine", tagLabel: "Type", anyTag: "Tout type",
      empty: "Aucun utilisateur ne correspond à ces filtres", pagination: "Pages", prev: "Page précédente", next: "Page suivante", pageOf: "Page {{page}} sur {{pages}}",
      origin: { direct: "Direct", agency: "Par une agence" },
      filter: { staff: "Personnel d'agence", traveller: "Voyageurs d'agence", pro: "PRO", admin: "Administrateurs" },
      tags: { staffOf: "Personnel · {{agency}}", travellerOf: "Voyageur · {{agency}}", pro: "PRO", proGift: "PRO offert", admin: "Admin" },
      cols: { user: "Utilisateur", tags: "Profil", trips: "Voyages", joined: "Inscription", lastActive: "Dernière activité" },
    },
    user: {
      ownTrips: "Voyages personnels", agencyTrips: "Voyages avec agence", usageMonth: "Usage ce mois-ci", usageAll: "Usage total",
      aiCredits_one: "{{count}} crédit IA", aiCredits_other: "{{count}} crédits IA",
      credits: "Crédits restants", creditsValue: "{{ai}} IA · {{trips}} voyages",
      pro: {
        title: "PRO", paid: "Paie PRO ({{source}}) jusqu'au {{date}}. Un PRO payé ne peut être ni offert par-dessus ni retiré ici.",
        giftUntil: "PRO offert jusqu'au {{date}}.", none: "Pas PRO. Vous pouvez l'offrir jusqu'à une date.",
        presets: "Durée", months_one: "{{count}} mois", months_other: "{{count}} mois",
        extendMonths_one: "+{{count}} mois", extendMonths_other: "+{{count}} mois",
        until: "Jusqu'au", grant: "Offrir PRO", update: "Changer la date", revoke: "Retirer le cadeau",
        revokeTitle: "Retirer le PRO offert ?", revokeBody: "Il cesse d'être PRO immédiatement. Rien de ce qu'il a créé n'est supprimé.",
        granted: "PRO offert", revoked: "Cadeau retiré", alreadyPaid: "Cet utilisateur paie déjà PRO", failed: "Impossible d'enregistrer le changement",
        historyGranted: "{{date}} · offert par {{actor}}", historyRevoked: "{{date}} · retiré par {{actor}}", unknownActor: "un admin supprimé",
        source: { STRIPE: "web", APP_STORE: "App Store", PLAY_STORE: "Google Play" },
      },
    },
  },
  adminAgencies: {
    title: "Agences",
    name: "Nom",
    contactEmail: "E-mail de contact",
    members: "Personnel",
    addMember: "Inviter",
    memberEmail: "E-mail de l'admin de l'agence",
    removeMember: "Retirer",
    mapsCap: "Plafond Maps (€/mois)",
    aiCap: "Requêtes IA / mois",
    activations_one: "{{count}} activé ce mois-ci",
    activations_other: "{{count}} activés ce mois-ci",
    downloadCsv: "CSV des activations",
    save: "Enregistrer",
    saved: "Enregistré",
    empty: "Pas encore d’agences.",
    invited: "Invitation envoyée à {{email}}",
    alreadyMember: "Déjà dans l'équipe.",
    failed: "Une erreur s'est produite",
    subtitle: "Les agences sont inscrites à la main. Leur personnel doit d'abord avoir un compte Gromly.",
    newTitle: "Nouvelle agence",
    staffEmpty: "Pas encore de personnel : ajoutez l'e-mail d'une personne ayant un compte Gromly.",
    limitsTitle: "Plafonds mensuels",
    limitsHint: "Ce que tous les voyages de l'agence peuvent dépenser ensemble en Maps et en IA.",
    billingTitle: "Facture",
    billingHint: "Une ligne par voyageur activé dans le mois.",
    statMaps: "Maps ce mois-ci",
    statAi: "IA ce mois-ci",
    statActivations: "Activés ce mois-ci",
    of: "{{used}} sur {{cap}}",
    logoHint: "Cliquez sur le logo pour le changer",
  },
} as const;

export default fr;
